import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "columns" }
const _hoisted_2 = {
  class: "account-box is-navigation p-0 mt-0",
  style: {"border":"none !important"}
}
const _hoisted_3 = { class: "account-menu me-5" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", {
  "aria-hidden": "true",
  class: "lnil lnil-user-alt"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "end" }, [
  /*#__PURE__*/_createElementVNode("i", {
    "aria-hidden": "true",
    class: "fas fa-arrow-right"
  })
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", {
  "aria-hidden": "true",
  class: "lnil lnil-quill"
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-cloud fs-3 align-middle me-3" }),
  /*#__PURE__*/_createTextVNode("Things Network")
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "end" }, [
  /*#__PURE__*/_createElementVNode("i", {
    "aria-hidden": "true",
    class: "fas fa-arrow-right"
  })
], -1)
const _hoisted_10 = [
  _hoisted_7,
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", {
  "aria-hidden": "true",
  class: "lnil lnil-quill"
}, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-compact-left fs-3 align-middle me-3" }),
  /*#__PURE__*/_createTextVNode("Volver")
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "end" }, [
  /*#__PURE__*/_createElementVNode("i", {
    "aria-hidden": "true",
    class: "fas fa-arrow-right"
  })
], -1)
const _hoisted_14 = [
  _hoisted_11,
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = { class: "form-head-inner text-center" }
const _hoisted_16 = { class: "text-center" }
const _hoisted_17 = {
  key: 0,
  class: "text-center py-5",
  style: {"background-color":"#fff"}
}
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "mt-3" }
const _hoisted_20 = {
  key: 0,
  class: "badge friBack1 fs-6"
}
const _hoisted_21 = {
  key: 1,
  class: "badge bg-danger fs-6"
}
const _hoisted_22 = { class: "mx-2" }
const _hoisted_23 = { class: "px-5 pt-2" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "pb-2 friBorderB" }, null, -1)
const _hoisted_25 = { class: "fs-6 mt-5" }
const _hoisted_26 = { class: "float-end" }
const _hoisted_27 = { class: "fs-6" }
const _hoisted_28 = { class: "float-end" }
const _hoisted_29 = { class: "fs-6" }
const _hoisted_30 = { class: "float-end" }
const _hoisted_31 = { class: "fs-6" }
const _hoisted_32 = { class: "float-end" }
const _hoisted_33 = { class: "fs-6" }
const _hoisted_34 = { class: "float-end" }
const _hoisted_35 = {
  key: 0,
  class: "fs-6"
}
const _hoisted_36 = { class: "float-end" }
const _hoisted_37 = { class: "fs-6 mt-5" }
const _hoisted_38 = { class: "float-end" }
const _hoisted_39 = { class: "fs-6 ps-2" }
const _hoisted_40 = {
  key: 0,
  class: "fs-6 float-end friColor1"
}
const _hoisted_41 = {
  key: 1,
  class: "fs-6 float-end friColor3"
}
const _hoisted_42 = { class: "fs-6 ps-2" }
const _hoisted_43 = { class: "float-end" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "fs-6 mt-5" }, "Notificaciones:", -1)
const _hoisted_45 = { class: "fs-6 ps-2" }
const _hoisted_46 = {
  key: 0,
  class: "float-end"
}
const _hoisted_47 = {
  key: 1,
  class: "float-end"
}
const _hoisted_48 = { class: "fs-6 ps-2" }
const _hoisted_49 = {
  key: 0,
  class: "float-end"
}
const _hoisted_50 = {
  key: 1,
  class: "float-end"
}
const _hoisted_51 = { class: "fs-6 ps-2" }
const _hoisted_52 = {
  key: 0,
  class: "float-end"
}
const _hoisted_53 = {
  key: 1,
  class: "float-end"
}
const _hoisted_54 = {
  key: 0,
  class: "ps-3"
}
const _hoisted_55 = { class: "float-end" }
const _hoisted_56 = {
  key: 1,
  class: "mx-5"
}
const _hoisted_57 = { class: "pt-2 pb-2 fs-5 friBack9 mt-3 text-left ps-3 br-5" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("span", { class: "align-middle" }, "Gateway", -1)
const _hoisted_59 = {
  key: 0,
  class: "pt-5 text-center text-xs3"
}
const _hoisted_60 = {
  key: 0,
  class: "pe-3"
}
const _hoisted_61 = {
  key: 1,
  class: "ps-3"
}
const _hoisted_62 = { class: "d-flex justify-content-center align-items-center fs-5" }
const _hoisted_63 = { class: "pt-2 pb-2 fs-5 friBack9 mt-3 text-left ps-3 br-5" }
const _hoisted_64 = { class: "align-middle" }
const _hoisted_65 = {
  fill: "clear",
  class: "float-end me-3 cursor-pointer"
}
const _hoisted_66 = { key: 0 }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-router friOpacity1",
  style: {"font-size":"50px","opacity":"0.5"}
}, null, -1)
const _hoisted_68 = { class: "fs-6 fw-bold" }
const _hoisted_69 = {
  style: {"font-size":"13px"},
  class: "mt-1"
}
const _hoisted_70 = {
  key: 0,
  class: "badge friBorder3 text-dark fw-normal text-x3"
}
const _hoisted_71 = { key: 1 }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("div", { class: "text-center mt-5" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "bi bi-router text-center mt-5",
    style: {"font-size":"80px","opacity":"0.5"}
  })
], -1)
const _hoisted_73 = /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, "No ha configurado gateways", -1)
const _hoisted_74 = [
  _hoisted_72,
  _hoisted_73
]
const _hoisted_75 = {
  key: 2,
  class: "mx-5"
}
const _hoisted_76 = { class: "pt-2 pb-2 fs-5 friBack9 mt-3 text-left ps-3 br-5" }
const _hoisted_77 = { class: "align-middle" }
const _hoisted_78 = { key: 0 }
const _hoisted_79 = {
  key: 0,
  fill: "clear",
  class: "float-end me-3"
}
const _hoisted_80 = {
  key: 0,
  style: {"padding-bottom":"80px"}
}
const _hoisted_81 = { class: "fs-6 fw-bold" }
const _hoisted_82 = {
  key: 0,
  class: "text-xs"
}
const _hoisted_83 = {
  key: 0,
  class: "text-xs friColor3"
}
const _hoisted_84 = { class: "text-xs3 friBorder1 ms-2 ps-3 my-4" }
const _hoisted_85 = { key: 0 }
const _hoisted_86 = { key: 0 }
const _hoisted_87 = { class: "fw-bold" }
const _hoisted_88 = { class: "fw-bold" }
const _hoisted_89 = { class: "fw-bold" }
const _hoisted_90 = { key: 1 }
const _hoisted_91 = {
  key: 0,
  class: "friColor3 fw-bold"
}
const _hoisted_92 = {
  key: 1,
  class: "friColor1 fw-bold"
}
const _hoisted_93 = { key: 2 }
const _hoisted_94 = { class: "fw-bold" }
const _hoisted_95 = { class: "fw-bold" }
const _hoisted_96 = { class: "fw-bold" }
const _hoisted_97 = { class: "fw-bold" }
const _hoisted_98 = {
  key: 3,
  class: "text-xs pt-1"
}
const _hoisted_99 = {
  key: 4,
  class: "text-xs pt-1"
}
const _hoisted_100 = { key: 1 }
const _hoisted_101 = {
  key: 2,
  class: "badge text-dark friBorder3 mt-1"
}
const _hoisted_102 = { key: 1 }
const _hoisted_103 = /*#__PURE__*/_createElementVNode("div", { class: "text-center mt-5" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "bi bi-wifi text-center mt-5",
    style: {"font-size":"80px","opacity":"0.5"}
  })
], -1)
const _hoisted_104 = /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, "No ha configurado dispositivos", -1)
const _hoisted_105 = [
  _hoisted_103,
  _hoisted_104
]
const _hoisted_106 = {
  key: 3,
  class: "mx-5"
}
const _hoisted_107 = { class: "pt-2 pb-2 fs-5 friBack9 mt-3 text-left ps-3 br-5" }
const _hoisted_108 = /*#__PURE__*/_createElementVNode("span", { class: "align-middle" }, "Escena", -1)
const _hoisted_109 = { class: "fs-3 text-center" }
const _hoisted_110 = { key: 2 }
const _hoisted_111 = /*#__PURE__*/_createElementVNode("div", { class: "text-left ps-3 pt-2 friColor1 fs-6" }, "Dispositivos *", -1)
const _hoisted_112 = { key: 3 }
const _hoisted_113 = /*#__PURE__*/_createElementVNode("div", { class: "text-left ps-3 pt-2 friColor1 fs-6" }, "Usuarios *", -1)
const _hoisted_114 = {
  key: 0,
  class: "pt-4 text-center text-xs3 mt-2"
}
const _hoisted_115 = {
  key: 0,
  class: "pe-3"
}
const _hoisted_116 = {
  key: 1,
  class: "ps-3"
}
const _hoisted_117 = { class: "d-flex justify-content-center align-items-center fs-5" }
const _hoisted_118 = {
  key: 0,
  class: "pt-2 pb-2 fs-5 friBack9 mt-3 text-left ps-3 br-5"
}
const _hoisted_119 = { class: "align-middle" }
const _hoisted_120 = { key: 0 }
const _hoisted_121 = {
  fill: "clear",
  class: "float-end me-3"
}
const _hoisted_122 = { key: 1 }
const _hoisted_123 = { class: "fs-6 fw-bold" }
const _hoisted_124 = {
  key: 0,
  class: "text-xs"
}
const _hoisted_125 = {
  key: 1,
  class: "badge text-dark friBorder3 mt-1"
}
const _hoisted_126 = /*#__PURE__*/_createElementVNode("div", { class: "pt-2 pb-2 fs-5 friBack9 text-left ps-3 br-5" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "align-middle" }, "Historial")
], -1)
const _hoisted_127 = { class: "text-left mt-2 ms-3 pt-2" }
const _hoisted_128 = {
  key: 1,
  class: "text-center"
}
const _hoisted_129 = /*#__PURE__*/_createElementVNode("div", { class: "text-center mt-5" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "bi bi-record-circle text-center mt-5",
    style: {"font-size":"80px","opacity":"0.5"}
  })
], -1)
const _hoisted_130 = /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, "No ha configurado escenas.", -1)
const _hoisted_131 = [
  _hoisted_129,
  _hoisted_130
]
const _hoisted_132 = {
  key: 4,
  class: "mx-5"
}
const _hoisted_133 = { class: "pt-2 pb-2 fs-5 friBack9 mt-3 text-left ps-3 br-5" }
const _hoisted_134 = /*#__PURE__*/_createElementVNode("span", { class: "align-middle" }, "Configuración", -1)
const _hoisted_135 = {
  fill: "clear",
  class: "float-end me-3 cursor-pointer"
}
const _hoisted_136 = { class: "text-center" }
const _hoisted_137 = ["src"]
const _hoisted_138 = /*#__PURE__*/_createElementVNode("label", { htmlFor: "file" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "bi bi-camera-fill friOpacity4",
    style: {"font-size":"30px"}
  })
], -1)
const _hoisted_139 = {
  key: 2,
  class: "text-center friColor3 fw-bold mt-3 mx-2"
}
const _hoisted_140 = /*#__PURE__*/_createElementVNode("div", { class: "pt-2 pb-2 fs-5 friBack9 mt-5 text-left ps-3 br-5" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "align-middle" }, "Límites de Uso")
], -1)
const _hoisted_141 = /*#__PURE__*/_createElementVNode("div", { class: "text-left ms-3 mt-5 fs-6 text-dark fw-bold" }, "Registros", -1)
const _hoisted_142 = /*#__PURE__*/_createElementVNode("div", { class: "text-left ms-3 mt-2 pt-5 fs-6 text-dark fw-bold" }, "Alarmas", -1)
const _hoisted_143 = { class: "d-flex justify-content-center align-items-center fs-5" }
const _hoisted_144 = {
  key: 5,
  class: "mx-5"
}
const _hoisted_145 = { class: "pt-2 pb-2 fs-5 friBack9 mt-3 text-left ps-3 br-5" }
const _hoisted_146 = { class: "align-middle" }
const _hoisted_147 = { key: 0 }
const _hoisted_148 = { class: "friUserCircle friBack1" }
const _hoisted_149 = { class: "fs-5" }
const _hoisted_150 = {
  key: 0,
  class: "text-xs"
}
const _hoisted_151 = {
  key: 1,
  class: "text-xs mt-2"
}
const _hoisted_152 = {
  key: 2,
  class: "text-xs"
}
const _hoisted_153 = {
  key: 3,
  class: "text-xs"
}
const _hoisted_154 = /*#__PURE__*/_createElementVNode("div", { class: "text-xs" }, "Notificaciones:", -1)
const _hoisted_155 = {
  key: 0,
  class: "text-xs"
}
const _hoisted_156 = {
  key: 1,
  class: "text-xs"
}
const _hoisted_157 = {
  key: 2,
  class: "text-xs"
}
const _hoisted_158 = {
  key: 3,
  class: "mt-1"
}
const _hoisted_159 = /*#__PURE__*/_createElementVNode("span", { class: "badge friColor3 friBorder3 friBack4" }, "Inactivo", -1)
const _hoisted_160 = [
  _hoisted_159
]
const _hoisted_161 = {
  key: 1,
  class: "pt-2"
}
const _hoisted_162 = /*#__PURE__*/_createElementVNode("div", { class: "text-center mt-5" }, "No dispone de usuarios activos.", -1)
const _hoisted_163 = [
  _hoisted_162
]
const _hoisted_164 = {
  key: 0,
  class: "text-left px-4 pt-3"
}
const _hoisted_165 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bold fs-4 ps-2" }, "Nuevo Gateway", -1)
const _hoisted_166 = { class: "text-end float-end pt-1" }
const _hoisted_167 = { class: "badge friBorder3 text-dark fw-normal text-x2" }
const _hoisted_168 = {
  key: 1,
  class: "text-center pt-5 px-5"
}
const _hoisted_169 = /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-router",
  style: {"font-size":"60px","opacity":"0.5"}
}, null, -1)
const _hoisted_170 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold fs-3" }, "Nuevo Gateway", -1)
const _hoisted_171 = { class: "badge friBorder3 text-dark fw-normal text-x2" }
const _hoisted_172 = { class: "fs-3 text-center px-5" }
const _hoisted_173 = { class: "mt-5" }
const _hoisted_174 = { class: "d-flex justify-content-center" }
const _hoisted_175 = {
  key: 1,
  class: "text-center",
  style: {"margin-top":"150px"}
}
const _hoisted_176 = /*#__PURE__*/_createElementVNode("div", { class: "mt-5 fs-5" }, "Creando", -1)
const _hoisted_177 = { class: "fs-4" }
const _hoisted_178 = /*#__PURE__*/_createElementVNode("div", { class: "mt-2" }, "Espere por favor ...", -1)
const _hoisted_179 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border friColor1 mt-5",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Cargando ...")
], -1)
const _hoisted_180 = {
  key: 0,
  class: "text-left px-4 pt-3"
}
const _hoisted_181 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bold fs-4 ps-2" }, "Nuevo Dispositivo", -1)
const _hoisted_182 = { class: "text-end float-end pt-1" }
const _hoisted_183 = { class: "badge friBorder3 text-dark fw-normal text-x2" }
const _hoisted_184 = {
  key: 1,
  class: "text-center pt-5 px-5"
}
const _hoisted_185 = /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-wifi",
  style: {"font-size":"80px","opacity":"0.5"}
}, null, -1)
const _hoisted_186 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold fs-3" }, "Nuevo Dispositivo", -1)
const _hoisted_187 = { class: "badge friBorder3 text-dark fw-normal text-x2" }
const _hoisted_188 = { class: "fs-3 text-center px-5 mt-5" }
const _hoisted_189 = {
  class: "mt-5",
  style: {"padding":"30px 0 120px 0"}
}
const _hoisted_190 = { class: "d-flex justify-content-center" }
const _hoisted_191 = {
  key: 1,
  class: "text-center",
  style: {"margin-top":"150px"}
}
const _hoisted_192 = /*#__PURE__*/_createElementVNode("div", { class: "mt-5 fs-5" }, "Creando", -1)
const _hoisted_193 = { class: "fs-4" }
const _hoisted_194 = /*#__PURE__*/_createElementVNode("div", { class: "mt-2" }, "Espere por favor ...", -1)
const _hoisted_195 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border friColor1 mt-5",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Cargando ...")
], -1)
const _hoisted_196 = {
  key: 0,
  class: "text-left px-5 pt-5 pb-0"
}
const _hoisted_197 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bold fs-4" }, "Nueva escena", -1)
const _hoisted_198 = [
  _hoisted_197
]
const _hoisted_199 = {
  key: 1,
  class: "text-center pt-3 px-5"
}
const _hoisted_200 = /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-record-circle",
  style: {"font-size":"80px","opacity":"0.5"}
}, null, -1)
const _hoisted_201 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold fs-3" }, "Nueva escena", -1)
const _hoisted_202 = { class: "fw-normal fs-6" }
const _hoisted_203 = { class: "fs-3 text-center ps-3 pe-4" }
const _hoisted_204 = {
  class: "mt-5",
  style: {"padding":"30px 0 120px 0"}
}
const _hoisted_205 = { class: "d-flex justify-content-center" }
const _hoisted_206 = {
  key: 1,
  class: "text-center",
  style: {"margin-top":"150px"}
}
const _hoisted_207 = /*#__PURE__*/_createElementVNode("div", { class: "mt-5 fs-5" }, "Creando", -1)
const _hoisted_208 = { class: "fs-4" }
const _hoisted_209 = /*#__PURE__*/_createElementVNode("div", { class: "mt-2" }, "Espere por favor ...", -1)
const _hoisted_210 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border friColor1 mt-5",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Cargando ...")
], -1)
const _hoisted_211 = {
  key: 1,
  class: "text-center w-100",
  style: {"margin":"150px 0"}
}
const _hoisted_212 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold fs-2" }, "Obteniendo métricas", -1)
const _hoisted_213 = /*#__PURE__*/_createElementVNode("div", { class: "mt-2" }, "Espere por favor ...", -1)
const _hoisted_214 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border friColor1 mt-5",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Cargando ...")
], -1)
const _hoisted_215 = [
  _hoisted_212,
  _hoisted_213,
  _hoisted_214
]
const _hoisted_216 = {
  key: 1,
  class: "text-center w-100",
  style: {"margin-top":"150px"}
}
const _hoisted_217 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold fs-1" }, "Aplicaciones", -1)
const _hoisted_218 = /*#__PURE__*/_createElementVNode("div", { class: "mt-2" }, "Espere por favor ...", -1)
const _hoisted_219 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border friColor1 mt-5",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Cargando ...")
], -1)
const _hoisted_220 = [
  _hoisted_217,
  _hoisted_218,
  _hoisted_219
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_toggle = _resolveComponent("ion-toggle")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_avatar = _resolveComponent("ion-avatar")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_IonButton = _resolveComponent("IonButton")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_modal = _resolveComponent("ion-modal")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["account-wrapper text-left", _ctx.isMobile ? '' : 'mt-5'])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (!_ctx.isMobile && _ctx.layout.app)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["column is-4 friAppcol1 ms-3", _ctx.isMobile ? '' : 'mt-5'])
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.layout.sections, (section, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: _normalizeClass(["account-menu-item cursor-pointer", _ctx.layout.section == section.name ? 'router-link-active router-link-exact-active' : '']),
                    onClick: ($event: any) => (_ctx.$router.push({ path: '/app/'+ _ctx.layout.app.id, query: { section:  section.name } }))
                  }, [
                    _hoisted_5,
                    _createElementVNode("span", null, [
                      _createElementVNode("i", {
                        class: _normalizeClass(section.icon + ' fs-3 align-middle me-3')
                      }, null, 2),
                      _createTextVNode(_toDisplayString(section.title), 1)
                    ]),
                    _hoisted_6
                  ], 10, _hoisted_4))
                }), 128)),
                _createElementVNode("div", {
                  class: "account-menu-item mt-2 cursor-pointer",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goTTN()))
                }, _hoisted_10),
                _createElementVNode("div", {
                  class: "account-menu-item mt-2 cursor-pointer",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goBack()))
                }, _hoisted_14)
              ])
            ])
          ], 2))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(["column px-0 mx-0", _ctx.isMobile ? '' : 'mt-5']),
        id: "friAppcol2",
        style: _normalizeStyle(_ctx.isMobile ? '' : 'padding-bottom: 100px;')
      }, [
        (_ctx.layout.app)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "account-box is-form is-footerless",
              style: _normalizeStyle(_ctx.isMobile ? 'border-bottom: none !important;' : '')
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["form-head stuck-header", _ctx.isMobile ? 'py-0' : 'py-3'])
              }, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("h4", {
                      class: _normalizeClass(["fw-bold", _ctx.isMobile ? 'fs-3 my-5 ms-2' : 'fs-4'])
                    }, _toDisplayString(_ctx.layout.app.name), 3)
                  ])
                ])
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["form-body p-0 m-0", _ctx.isMobile ? 'pt-0' : 'p-2'])
              }, [
                (_ctx.layout.section)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (_ctx.layout.app && _ctx.layout.section == 'dashboard')
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(_ctx.isMobile ? 'friBackApp friBackWhite' : ''),
                            style: {"padding":"0"}
                          }, [
                            (_ctx.layout.app.logo)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                  _createElementVNode("img", {
                                    src: _ctx.layout.app.logo,
                                    width: "120",
                                    height: "120"
                                  }, null, 8, _hoisted_18),
                                  _createElementVNode("div", _hoisted_19, [
                                    (_ctx.layout.app.active)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_20, "Activo"))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_21, "Inactivo"))
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_22, [
                              _createElementVNode("div", _hoisted_23, [
                                _hoisted_24,
                                _createElementVNode("div", _hoisted_25, [
                                  _createTextVNode("ID: "),
                                  _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.layout.app.id), 1)
                                ]),
                                _createElementVNode("div", _hoisted_27, [
                                  _createTextVNode("Creado: "),
                                  _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.layout.helper.getDateFormatFb(_ctx.layout.app.createdAt, "date")), 1)
                                ]),
                                _createElementVNode("div", _hoisted_29, [
                                  _createTextVNode("Gateways: "),
                                  _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.layout.app.gateways && _ctx.layout.app.gateways.gateways ? Object.keys(_ctx.layout.app.gateways.gateways).length : 0), 1)
                                ]),
                                _createElementVNode("div", _hoisted_31, [
                                  _createElementVNode("span", {
                                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push({ path: '/app/'+ _ctx.layout.app.id, query: { section:  'devices' } }))),
                                    class: "cursor-pointer friColor1"
                                  }, "Equipos y sensores:"),
                                  _createElementVNode("span", _hoisted_32, [
                                    _createTextVNode(_toDisplayString(_ctx.layout.app.devices && _ctx.layout.app.devices.devices ? Object.keys(_ctx.layout.app.devices.devices).length : 0) + " ", 1),
                                    _createElementVNode("span", null, "/ " + _toDisplayString(_ctx.layout.app.limits.devices), 1)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_33, [
                                  _createElementVNode("span", {
                                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push({ path: '/app/'+ _ctx.layout.app.id, query: { section:  'scenes' } }))),
                                    class: "cursor-pointer friColor1"
                                  }, "Escenas:"),
                                  _createElementVNode("span", _hoisted_34, [
                                    _createTextVNode(_toDisplayString(_ctx.layout.app.scenes && _ctx.layout.app.scenes.scenes ? Object.keys(_ctx.layout.app.scenes.scenes).length : 0) + " ", 1),
                                    _createElementVNode("span", null, "/ " + _toDisplayString(_ctx.layout.app.limits.scenes), 1)
                                  ])
                                ]),
                                (_ctx.layout.app?.users?.users)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                      _createElementVNode("span", {
                                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.push({ path: '/app/'+ _ctx.layout.app.id, query: { section:  'users' } }))),
                                        class: "cursor-pointer friColor1"
                                      }, "Usuarios:"),
                                      _createElementVNode("span", _hoisted_36, [
                                        _createTextVNode(_toDisplayString(Object.keys(_ctx.layout.app?.users?.users).length) + " ", 1),
                                        _createElementVNode("span", null, "/ " + _toDisplayString(_ctx.layout.app.limits.users), 1)
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.layout.app?.client)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createElementVNode("div", _hoisted_37, [
                                        _createTextVNode("Cliente: "),
                                        _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.layout.app.client.first) + " " + _toDisplayString(_ctx.layout.app.client.last), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_39, [
                                        _createTextVNode("Estado: "),
                                        (_ctx.layout.app.client.active)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_40, "Activo"))
                                          : (_openBlock(), _createElementBlock("span", _hoisted_41, "Inactivo"))
                                      ]),
                                      _createElementVNode("div", _hoisted_42, [
                                        _createTextVNode("Inicio de sesión: "),
                                        _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.layout.helper.getDateFormatFb(_ctx.layout.app.client.lastLogin, "full")), 1)
                                      ])
                                    ], 64))
                                  : _createCommentVNode("", true),
                                (_ctx.layout.app?.limits && _ctx.layout.app?.limits?.notify)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                      _hoisted_44,
                                      _createElementVNode("div", _hoisted_45, [
                                        _createTextVNode("Email: "),
                                        (_ctx.layout.app.limits.notify.email)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_46, "Activo"))
                                          : (_openBlock(), _createElementBlock("span", _hoisted_47, "Inactivo"))
                                      ]),
                                      _createElementVNode("div", _hoisted_48, [
                                        _createTextVNode("Whatsapp: "),
                                        (_ctx.layout.app.limits.notify.whatsapp)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_49, "Activo"))
                                          : (_openBlock(), _createElementBlock("span", _hoisted_50, "Inactivo"))
                                      ]),
                                      _createElementVNode("div", _hoisted_51, [
                                        _createTextVNode("SMS: "),
                                        (_ctx.layout.app.limits.notify.sms)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_52, "Activo"))
                                          : (_openBlock(), _createElementBlock("span", _hoisted_53, "Inactivo"))
                                      ]),
                                      (_ctx.layout.app.limits.notify.sms)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                                            _createTextVNode(" Límite: "),
                                            _createElementVNode("span", _hoisted_55, _toDisplayString(_ctx.layout.app.limits.notify.maxsms) + " sms", 1)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ], 2))
                        : _createCommentVNode("", true),
                      (_ctx.layout.app && _ctx.layout.section == 'gateway')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                            (_ctx.layout.gateway)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createElementVNode("div", _hoisted_57, [
                                    _hoisted_58,
                                    _createElementVNode("div", {
                                      fill: "clear",
                                      class: "float-end me-3 cursor-pointer",
                                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.layout.gateway = false))
                                    }, [
                                      _createVNode(_component_ion_icon, {
                                        icon: _ctx.chevronBack,
                                        class: _normalizeClass(["p-0 m-0 font-bold align-top p-0 m-0", _ctx.isMobile ? 'fs-1' : 'fs-2'])
                                      }, null, 8, ["icon", "class"])
                                    ])
                                  ]),
                                  _createElementVNode("div", null, [
                                    _createVNode(_component_ion_list, { class: "p-0 mt-0 me-3" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_item, {
                                          lines: "full",
                                          class: "border-none",
                                          style: {"--ion-item-border-color":"#ccc"}
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ion_label, {
                                              position: "floating",
                                              class: _normalizeClass(["friColor1", _ctx.isMobile ? 'fs-4' : ' fs-5'])
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode("ID *")
                                              ]),
                                              _: 1
                                            }, 8, ["class"]),
                                            _createVNode(_component_ion_input, {
                                              modelValue: _ctx.layout.gateway.gatewayId,
                                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.layout.gateway.gatewayId) = $event)),
                                              type: "text",
                                              autocomplete: "off",
                                              disabled: true
                                            }, null, 8, ["modelValue"])
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_ion_item, {
                                          lines: "full",
                                          class: "border-none",
                                          style: {"--ion-item-border-color":"#ccc"}
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ion_label, {
                                              position: "floating",
                                              class: _normalizeClass(["friColor1", _ctx.isMobile ? 'fs-4' : ' fs-5'])
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode("Nombre *")
                                              ]),
                                              _: 1
                                            }, 8, ["class"]),
                                            _createVNode(_component_ion_input, {
                                              modelValue: _ctx.layout.gateway.name,
                                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.layout.gateway.name) = $event)),
                                              type: "text",
                                              autocomplete: "off"
                                            }, null, 8, ["modelValue"])
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_ion_item, {
                                          lines: "full",
                                          class: "border-none",
                                          style: {"--ion-item-border-color":"#ccc"}
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ion_label, {
                                              position: "floating",
                                              class: _normalizeClass(["friColor1", _ctx.isMobile ? 'fs-4' : ' fs-5'])
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode("EUI *")
                                              ]),
                                              _: 1
                                            }, 8, ["class"]),
                                            _createVNode(_component_ion_input, {
                                              modelValue: _ctx.layout.gateway.eui,
                                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.layout.gateway.eui) = $event)),
                                              type: "text",
                                              autocomplete: "off",
                                              disabled: true
                                            }, null, 8, ["modelValue"])
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_ion_row, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ion_col, { class: "m-0 p-0" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_ion_item, {
                                                  lines: "full",
                                                  class: "border-none",
                                                  style: {"--ion-item-border-color":"#ccc"}
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_ion_label, {
                                                      position: "floating",
                                                      class: _normalizeClass(["friColor1", _ctx.isMobile ? 'fs-4' : ' fs-5'])
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode("Marca")
                                                      ]),
                                                      _: 1
                                                    }, 8, ["class"]),
                                                    _createVNode(_component_ion_input, {
                                                      modelValue: _ctx.layout.gateway.device.brand,
                                                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.layout.gateway.device.brand) = $event)),
                                                      type: "text",
                                                      autocomplete: "off"
                                                    }, null, 8, ["modelValue"])
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_ion_col, { class: "m-0 p-0" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_ion_item, {
                                                  lines: "full",
                                                  class: "border-none",
                                                  style: {"--ion-item-border-color":"#ccc"}
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_ion_label, {
                                                      position: "floating",
                                                      class: _normalizeClass(["friColor1", _ctx.isMobile ? 'fs-4' : ' fs-5'])
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode("Modelo")
                                                      ]),
                                                      _: 1
                                                    }, 8, ["class"]),
                                                    _createVNode(_component_ion_input, {
                                                      modelValue: _ctx.layout.gateway.device.model,
                                                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.layout.gateway.device.model) = $event)),
                                                      type: "text",
                                                      autocomplete: "off"
                                                    }, null, 8, ["modelValue"])
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_ion_item, {
                                          lines: "full",
                                          class: "border-none",
                                          style: {"--ion-item-border-color":"#ccc"}
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ion_label, {
                                              position: "floating",
                                              class: _normalizeClass(["friColor1", _ctx.isMobile ? 'fs-4' : ' fs-5'])
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode("Server address *")
                                              ]),
                                              _: 1
                                            }, 8, ["class"]),
                                            _createVNode(_component_ion_input, {
                                              modelValue: _ctx.layout.gateway.serverAdress,
                                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.layout.gateway.serverAdress) = $event)),
                                              type: "text",
                                              autocomplete: "off",
                                              disabled: true
                                            }, null, 8, ["modelValue"])
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_ion_item, {
                                          lines: "full",
                                          class: "border-none",
                                          style: {"--ion-item-border-color":"#ccc"}
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ion_label, {
                                              position: "floating",
                                              class: _normalizeClass(["friColor1", _ctx.isMobile ? 'fs-4' : ' fs-5'])
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode("Frecuencia *")
                                              ]),
                                              _: 1
                                            }, 8, ["class"]),
                                            _createVNode(_component_ion_select, {
                                              interface: "popover",
                                              modelValue: _ctx.layout.gateway.frequencyPlanId,
                                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.layout.gateway.frequencyPlanId) = $event)),
                                              class: "pfInputValue"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_ion_select_option, { value: "EU_863_870_TTN" }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode("EU_863_870_TTN")
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }, 8, ["modelValue"])
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_ion_item, {
                                          lines: "full",
                                          class: "border-none",
                                          style: {"--ion-item-border-color":"#ccc"}
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ion_label, {
                                              position: "floating",
                                              class: _normalizeClass(["friColor1", _ctx.isMobile ? 'fs-4' : ' fs-5'])
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode("Nº de serie")
                                              ]),
                                              _: 1
                                            }, 8, ["class"]),
                                            _createVNode(_component_ion_input, {
                                              modelValue: _ctx.layout.gateway.device.serial,
                                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.layout.gateway.device.serial) = $event)),
                                              type: "text",
                                              autocomplete: "off"
                                            }, null, 8, ["modelValue"])
                                          ]),
                                          _: 1
                                        }),
                                        (_ctx.layout.gateway.keys)
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                              (_ctx.layout.gateway.keys?.cups && _ctx.layout.gateway.keys?.cups?.key)
                                                ? (_openBlock(), _createBlock(_component_ion_item, {
                                                    key: 0,
                                                    lines: "full",
                                                    class: "border-none",
                                                    style: {"--ion-item-border-color":"#ccc"}
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_ion_label, {
                                                        position: "floating",
                                                        class: _normalizeClass(["friColor1", _ctx.isMobile ? 'fs-4' : ' fs-5'])
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode("Cups key *")
                                                        ]),
                                                        _: 1
                                                      }, 8, ["class"]),
                                                      _createVNode(_component_ion_input, {
                                                        modelValue: _ctx.layout.gateway.keys.cups.key,
                                                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.layout.gateway.keys.cups.key) = $event)),
                                                        type: "text",
                                                        autocomplete: "off",
                                                        disabled: true
                                                      }, null, 8, ["modelValue"])
                                                    ]),
                                                    _: 1
                                                  }))
                                                : _createCommentVNode("", true),
                                              (_ctx.layout.gateway.keys?.lns && _ctx.layout.gateway.keys?.lns?.key)
                                                ? (_openBlock(), _createBlock(_component_ion_item, {
                                                    key: 1,
                                                    lines: "full",
                                                    class: "border-none",
                                                    style: {"--ion-item-border-color":"#ccc"}
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_ion_label, {
                                                        position: "floating",
                                                        class: _normalizeClass(["friColor1", _ctx.isMobile ? 'fs-4' : ' fs-5'])
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode("Lns key *")
                                                        ]),
                                                        _: 1
                                                      }, 8, ["class"]),
                                                      _createVNode(_component_ion_input, {
                                                        modelValue: _ctx.layout.gateway.keys.lns.key,
                                                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.layout.gateway.keys.lns.key) = $event)),
                                                        type: "text",
                                                        autocomplete: "off"
                                                      }, null, 8, ["modelValue"])
                                                    ]),
                                                    _: 1
                                                  }))
                                                : _createCommentVNode("", true)
                                            ], 64))
                                          : _createCommentVNode("", true),
                                        _createVNode(_component_ion_item, {
                                          class: "mt-2 border-none",
                                          lines: "full",
                                          style: {"--ion-item-border-color":"#ccc"}
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ion_label, null, {
                                              default: _withCtx(() => [
                                                _createTextVNode("Activo")
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_ion_toggle, {
                                              "enable-on-off-labels": true,
                                              slot: "end",
                                              modelValue: _ctx.layout.gateway.active,
                                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.layout.gateway.active) = $event))
                                            }, null, 8, ["modelValue"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    (_ctx.layout.gateway.createdAt)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                                          (_ctx.layout.gateway.createdAt)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_60, _toDisplayString(_ctx.layout.helper.getDateFormatFb(_ctx.layout.gateway.createdAt)), 1))
                                            : _createCommentVNode("", true),
                                          _createTextVNode("| "),
                                          (_ctx.layout.gateway.updatedAt)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_61, " Actualizado el " + _toDisplayString(_ctx.layout.helper.getDateFormatFb(_ctx.layout.gateway.updatedAt)), 1))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("div", {
                                      style: _normalizeStyle(_ctx.isMobile ? 'margin-top: 20px; margin-bottom: 80px;' : 'margin-top: 20px;')
                                    }, [
                                      _createElementVNode("div", _hoisted_62, [
                                        _createElementVNode("div", {
                                          class: "pe-4 fw-bold text-danger friOpacity6 cursor-pointer",
                                          onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.removeGateway()))
                                        }, "ELIMINAR"),
                                        _createElementVNode("div", {
                                          class: "fw-bold friColor1 text-end float-end ps-4 cursor-pointer",
                                          onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.saveGateway()))
                                        }, "GUARDAR")
                                      ])
                                    ], 4)
                                  ])
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createElementVNode("div", _hoisted_63, [
                                    _createElementVNode("span", _hoisted_64, "Gateways (" + _toDisplayString(Object.keys(_ctx.layout.app.gateways.gateways).length) + ")", 1),
                                    _createElementVNode("div", _hoisted_65, [
                                      _createVNode(_component_ion_icon, {
                                        icon: _ctx.refreshOutline,
                                        onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.reLoad())),
                                        class: _normalizeClass(["font-bold align-middle cursor-pointer pe-2", _ctx.isMobile ? 'fs-2' : 'fs-3'])
                                      }, null, 8, ["icon", "class"]),
                                      _createVNode(_component_ion_icon, {
                                        icon: _ctx.add,
                                        class: _normalizeClass(["p-0 m-0 font-bold align-middle p-0 m-0", _ctx.isMobile ? 'fs-1' : 'fs-2']),
                                        onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.layout.addGateway = true))
                                      }, null, 8, ["icon", "class"])
                                    ])
                                  ]),
                                  (_ctx.layout.app.gateways && _ctx.layout.app.gateways.gateways)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        (Object.keys(_ctx.layout.app.gateways.gateways).length)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                                              (_ctx.layout.app && _ctx.layout.app.gateways && _ctx.layout.app.gateways.gateways && Object.keys(_ctx.layout.app.gateways.gateways).length)
                                                ? (_openBlock(), _createBlock(_component_ion_list, { key: 0 }, {
                                                    default: _withCtx(() => [
                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.layout.app.gateways.gateways, (gateway, gatewayId) => {
                                                        return (_openBlock(), _createBlock(_component_ion_item, {
                                                          detail: "",
                                                          key: gatewayId,
                                                          style: {"--ion-item-border-color":"#e4e3e3"},
                                                          class: "cursor-pointer pt-2",
                                                          onClick: ($event: any) => (_ctx.layout.gateway = gateway)
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_ion_avatar, {
                                                              slot: "start",
                                                              class: "mt-0",
                                                              style: {"width":"55px","height":"60px"}
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _hoisted_67
                                                              ]),
                                                              _: 1
                                                            }),
                                                            _createVNode(_component_ion_label, { class: "pb-1" }, {
                                                              default: _withCtx(() => [
                                                                _createElementVNode("h2", _hoisted_68, _toDisplayString(gateway.name), 1),
                                                                _createElementVNode("p", _hoisted_69, [
                                                                  (gateway.device?.model)
                                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_70, _toDisplayString(gateway.device.brand) + " / " + _toDisplayString(gateway.device?.model), 1))
                                                                    : _createCommentVNode("", true)
                                                                ])
                                                              ]),
                                                              _: 2
                                                            }, 1024)
                                                          ]),
                                                          _: 2
                                                        }, 1032, ["onClick"]))
                                                      }), 128))
                                                    ]),
                                                    _: 1
                                                  }))
                                                : _createCommentVNode("", true)
                                            ]))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_71, _hoisted_74))
                                      ], 64))
                                    : _createCommentVNode("", true)
                                ], 64))
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.layout.app && _ctx.layout.section == 'devices')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                            _createElementVNode("div", _hoisted_76, [
                              _createElementVNode("span", _hoisted_77, [
                                _createTextVNode("Dispositivos "),
                                (_ctx.layout.app.devices)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_78, [
                                      _createTextVNode("(" + _toDisplayString(Object.keys(_ctx.layout.app.devices.devices).length) + "/", 1),
                                      _createElementVNode("span", null, _toDisplayString(_ctx.layout.app.limits.devices), 1),
                                      _createTextVNode(")")
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              (_ctx.layout.app.devices && _ctx.layout.app.limits.devices > Object.keys(_ctx.layout.app.devices.devices).length)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                                    _createVNode(_component_ion_icon, {
                                      icon: _ctx.refreshOutline,
                                      onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.reLoad())),
                                      class: _normalizeClass(["font-bold align-middle cursor-pointer pe-2", _ctx.isMobile ? 'fs-2' : 'fs-3'])
                                    }, null, 8, ["icon", "class"]),
                                    _createVNode(_component_ion_icon, {
                                      icon: _ctx.add,
                                      onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.layout.newDevice.addBox = true)),
                                      class: _normalizeClass(["p-0 m-0 font-bold align-middle cursor-pointer", _ctx.isMobile ? 'fs-1' : 'fs-2'])
                                    }, null, 8, ["icon", "class"])
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            (_ctx.layout.app.devices && _ctx.layout.app.devices.devices)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  (Object.keys(_ctx.layout.app.devices.devices).length)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                                        (_ctx.layout.app && _ctx.layout.app.devices && _ctx.layout.app.devices.devices && Object.keys(_ctx.layout.app.devices.devices).length)
                                          ? (_openBlock(), _createBlock(_component_ion_list, { key: 0 }, {
                                              default: _withCtx(() => [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.layout.app.devices.devices, (device, deviceId) => {
                                                  return (_openBlock(), _createBlock(_component_ion_item, {
                                                    detail: "",
                                                    key: deviceId,
                                                    style: {"--ion-item-border-color":"#e4e3e3"},
                                                    class: "cursor-pointer mb-1",
                                                    onClick: ($event: any) => (_ctx.selDevice(device))
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_ion_label, null, {
                                                        default: _withCtx(() => [
                                                          _createElementVNode("h2", _hoisted_81, _toDisplayString(device.name), 1),
                                                          (device.typeName)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_82, _toDisplayString(device.typeName), 1))
                                                            : _createCommentVNode("", true),
                                                          (device.status?.alarm?.status && device?.status?.alarm?.alarms)
                                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                                (device.status?.alarm?.status && device?.status?.alarm?.alarms && Object.keys(device.status.alarm.alarms).length)
                                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_83, _toDisplayString(Object.keys(device.status.alarm.alarms).length) + " alarmas activas", 1))
                                                                  : _createCommentVNode("", true)
                                                              ], 64))
                                                            : _createCommentVNode("", true),
                                                          _createElementVNode("div", _hoisted_84, [
                                                            (device.status && device.status.msg)
                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                                                                  (device.status && device.status.msg.TempC_SHT)
                                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                                                                        _createVNode(_component_ion_row, null, {
                                                                          default: _withCtx(() => [
                                                                            (device.status.msg.TempC_SHT)
                                                                              ? (_openBlock(), _createBlock(_component_ion_col, { key: 0 }, {
                                                                                  default: _withCtx(() => [
                                                                                    _createTextVNode("Temperatura"),
                                                                                    _createElementVNode("div", _hoisted_87, _toDisplayString(device.status.msg.TempC_SHT) + " ºC", 1)
                                                                                  ]),
                                                                                  _: 2
                                                                                }, 1024))
                                                                              : _createCommentVNode("", true),
                                                                            (device.status.msg.Hum_SHT)
                                                                              ? (_openBlock(), _createBlock(_component_ion_col, { key: 1 }, {
                                                                                  default: _withCtx(() => [
                                                                                    _createTextVNode("Humedad"),
                                                                                    _createElementVNode("div", _hoisted_88, _toDisplayString(device.status.msg.Hum_SHT) + " %", 1)
                                                                                  ]),
                                                                                  _: 2
                                                                                }, 1024))
                                                                              : _createCommentVNode("", true),
                                                                            (device.hasOwnProperty('externalInput') && device.externalInput!='none')
                                                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                                                                  (device.status.msg.hasOwnProperty('TempC_DS'))
                                                                                    ? (_openBlock(), _createBlock(_component_ion_col, { key: 0 }, {
                                                                                        default: _withCtx(() => [
                                                                                          _createTextVNode("Sonda externa"),
                                                                                          _createElementVNode("div", _hoisted_89, _toDisplayString(device.status.msg.TempC_DS) + " ºC", 1)
                                                                                        ]),
                                                                                        _: 2
                                                                                      }, 1024))
                                                                                    : _createCommentVNode("", true)
                                                                                ], 64))
                                                                              : _createCommentVNode("", true)
                                                                          ]),
                                                                          _: 2
                                                                        }, 1024)
                                                                      ]))
                                                                    : _createCommentVNode("", true),
                                                                  (device.status && device.status.msg.hasOwnProperty('DOOR_OPEN_STATUS'))
                                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
                                                                        (device.status.msg.DOOR_OPEN_STATUS == 1)
                                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_91, "Abierto"))
                                                                          : (_openBlock(), _createElementBlock("div", _hoisted_92, "Cerrado"))
                                                                      ]))
                                                                    : _createCommentVNode("", true),
                                                                  (device.status && device.status.msg.co2)
                                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
                                                                        _createVNode(_component_ion_row, null, {
                                                                          default: _withCtx(() => [
                                                                            (device.status.msg.temperature)
                                                                              ? (_openBlock(), _createBlock(_component_ion_col, { key: 0 }, {
                                                                                  default: _withCtx(() => [
                                                                                    _createTextVNode("Temperatura"),
                                                                                    _createElementVNode("div", _hoisted_94, _toDisplayString(device.status.msg.temperature) + " ºC", 1)
                                                                                  ]),
                                                                                  _: 2
                                                                                }, 1024))
                                                                              : _createCommentVNode("", true),
                                                                            (device.status.msg.humidity)
                                                                              ? (_openBlock(), _createBlock(_component_ion_col, { key: 1 }, {
                                                                                  default: _withCtx(() => [
                                                                                    _createTextVNode("Humedad"),
                                                                                    _createElementVNode("div", _hoisted_95, _toDisplayString(device.status.msg.humidity) + " %", 1)
                                                                                  ]),
                                                                                  _: 2
                                                                                }, 1024))
                                                                              : _createCommentVNode("", true),
                                                                            (device.status.msg.air_pressure)
                                                                              ? (_openBlock(), _createBlock(_component_ion_col, { key: 2 }, {
                                                                                  default: _withCtx(() => [
                                                                                    _createTextVNode("CO2"),
                                                                                    _createElementVNode("div", _hoisted_96, _toDisplayString(device.status.msg.co2) + " ppm", 1)
                                                                                  ]),
                                                                                  _: 2
                                                                                }, 1024))
                                                                              : _createCommentVNode("", true),
                                                                            (device.status.msg.air_pressure)
                                                                              ? (_openBlock(), _createBlock(_component_ion_col, { key: 3 }, {
                                                                                  default: _withCtx(() => [
                                                                                    _createTextVNode("Presión del aire"),
                                                                                    _createElementVNode("div", _hoisted_97, _toDisplayString(device.status.msg.air_pressure) + " hPa", 1)
                                                                                  ]),
                                                                                  _: 2
                                                                                }, 1024))
                                                                              : _createCommentVNode("", true)
                                                                          ]),
                                                                          _: 2
                                                                        }, 1024)
                                                                      ]))
                                                                    : _createCommentVNode("", true),
                                                                  (device.status)
                                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_98, _toDisplayString(_ctx.layout.helper.getDateFormatFb(device.status.date)), 1))
                                                                    : _createCommentVNode("", true),
                                                                  (device.status)
                                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
                                                                        _createElementVNode("span", null, "Hace: " + _toDisplayString(((new Date().getTime() - new Date((device.status.date.seconds * 1000) + (device.status.date.nanoseconds / 1000000)).getTime()) / (1000 * 60)).toFixed(0)) + " minutos", 1)
                                                                      ]))
                                                                    : _createCommentVNode("", true)
                                                                ]))
                                                              : (_openBlock(), _createElementBlock("div", _hoisted_100, " Todavía no se han recibido datos ... "))
                                                          ]),
                                                          (!device.active)
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_101, "Inactivo"))
                                                            : _createCommentVNode("", true)
                                                        ]),
                                                        _: 2
                                                      }, 1024)
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["onClick"]))
                                                }), 128))
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_102, _hoisted_105))
                                ], 64))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.layout.app && _ctx.layout.section == 'scenes')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_106, [
                            (_ctx.layout.scene)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createElementVNode("div", _hoisted_107, [
                                    _hoisted_108,
                                    _createElementVNode("div", {
                                      fill: "clear",
                                      class: "float-end me-3 cursor-pointer",
                                      onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.backScene()))
                                    }, [
                                      _createVNode(_component_ion_icon, {
                                        icon: _ctx.chevronBack,
                                        class: _normalizeClass(["p-0 m-0 font-bold align-top p-0 m-0", _ctx.isMobile ? 'fs-1' : 'fs-2'])
                                      }, null, 8, ["icon", "class"])
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_109, [
                                    _createVNode(_component_ion_list, { class: "m-0 p-0" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_item, {
                                          lines: "full",
                                          class: "border-none",
                                          style: {"--ion-item-border-color":"#ccc"}
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ion_label, {
                                              position: "floating",
                                              class: "friColor1 fs-6"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode("Tipo *")
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_ion_select, {
                                              interface: "popover",
                                              modelValue: _ctx.layout.scene.type,
                                              "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.layout.scene.type) = $event)),
                                              class: "pfInputValue"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_ion_select_option, { value: "coldroom" }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode("Cámara frigorífica")
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_ion_select_option, { value: "handlingroom" }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode("Sala de manipulación")
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }, 8, ["modelValue"])
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_ion_item, {
                                          lines: "full",
                                          class: "border-none",
                                          style: {"--ion-item-border-color":"#ccc"}
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ion_label, {
                                              position: "floating",
                                              class: "friColor1 fs-6"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode("Nombre *")
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_ion_input, {
                                              modelValue: _ctx.layout.scene.name,
                                              "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.layout.scene.name) = $event)),
                                              type: "text",
                                              autocomplete: "off"
                                            }, null, 8, ["modelValue"])
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_ion_item, {
                                          lines: "full",
                                          class: "border-none",
                                          style: {"--ion-item-border-color":"#ccc"}
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ion_label, {
                                              position: "floating",
                                              class: "friColor1 fs-6"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode("Tipología del producto *")
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_ion_input, {
                                              modelValue: _ctx.layout.scene.specs.product.type,
                                              "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.layout.scene.specs.product.type) = $event)),
                                              type: "text",
                                              autocomplete: "off"
                                            }, null, 8, ["modelValue"])
                                          ]),
                                          _: 1
                                        }),
                                        (_ctx.layout.scene.specs && _ctx.layout.scene.specs.room)
                                          ? (_openBlock(), _createBlock(_component_ion_row, { key: 0 }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_ion_col, { class: "m-0 p-0" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_ion_item, {
                                                      lines: "full",
                                                      class: "border-none",
                                                      style: {"--ion-item-border-color":"#ccc"}
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_ion_label, {
                                                          position: "floating",
                                                          class: "friColor1 fs-6"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode("Ancho (m) *")
                                                          ]),
                                                          _: 1
                                                        }),
                                                        _createVNode(_component_ion_input, {
                                                          modelValue: _ctx.layout.scene.specs.room.width,
                                                          "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.layout.scene.specs.room.width) = $event)),
                                                          type: "text",
                                                          autocomplete: "off"
                                                        }, null, 8, ["modelValue"])
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_ion_col, { class: "m-0 p-0" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_ion_item, {
                                                      lines: "full",
                                                      class: "border-none",
                                                      style: {"--ion-item-border-color":"#ccc"}
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_ion_label, {
                                                          position: "floating",
                                                          class: "friColor1 fs-6"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode("Alto (m) *")
                                                          ]),
                                                          _: 1
                                                        }),
                                                        _createVNode(_component_ion_input, {
                                                          modelValue: _ctx.layout.scene.specs.room.height,
                                                          "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.layout.scene.specs.room.height) = $event)),
                                                          type: "text",
                                                          autocomplete: "off"
                                                        }, null, 8, ["modelValue"])
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_ion_col, { class: "m-0 p-0" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_ion_item, {
                                                      lines: "full",
                                                      class: "border-none",
                                                      style: {"--ion-item-border-color":"#ccc"}
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_ion_label, {
                                                          position: "floating",
                                                          class: "friColor1 fs-6"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode("Largo (m) *")
                                                          ]),
                                                          _: 1
                                                        }),
                                                        _createVNode(_component_ion_input, {
                                                          modelValue: _ctx.layout.scene.specs.room.length,
                                                          "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.layout.scene.specs.room.length) = $event)),
                                                          type: "text",
                                                          autocomplete: "off"
                                                        }, null, 8, ["modelValue"])
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true),
                                        (_ctx.layout.scene.type && _ctx.layout.scene.type == 'coldroom')
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                              (_ctx.layout.scene.specs && _ctx.layout.scene.specs.door)
                                                ? (_openBlock(), _createBlock(_component_ion_row, { key: 0 }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_ion_col, { class: "m-0 p-0" }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_ion_item, {
                                                            lines: "full",
                                                            class: "border-none",
                                                            style: {"--ion-item-border-color":"#ccc"}
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_component_ion_label, {
                                                                position: "floating",
                                                                class: "friColor1 fs-6"
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createTextVNode("Ancho puerta (m) *")
                                                                ]),
                                                                _: 1
                                                              }),
                                                              _createVNode(_component_ion_input, {
                                                                modelValue: _ctx.layout.scene.specs.door.width,
                                                                "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.layout.scene.specs.door.width) = $event)),
                                                                type: "text",
                                                                autocomplete: "off"
                                                              }, null, 8, ["modelValue"])
                                                            ]),
                                                            _: 1
                                                          })
                                                        ]),
                                                        _: 1
                                                      }),
                                                      _createVNode(_component_ion_col, { class: "m-0 p-0" }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_ion_item, {
                                                            lines: "full",
                                                            class: "border-none",
                                                            style: {"--ion-item-border-color":"#ccc"}
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_component_ion_label, {
                                                                position: "floating",
                                                                class: "friColor1 fs-6"
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createTextVNode("Alto puerta (m) *")
                                                                ]),
                                                                _: 1
                                                              }),
                                                              _createVNode(_component_ion_input, {
                                                                modelValue: _ctx.layout.scene.specs.door.height,
                                                                "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.layout.scene.specs.door.height) = $event)),
                                                                type: "text",
                                                                autocomplete: "off"
                                                              }, null, 8, ["modelValue"])
                                                            ]),
                                                            _: 1
                                                          })
                                                        ]),
                                                        _: 1
                                                      }),
                                                      _createVNode(_component_ion_col, { class: "m-0 p-0" }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_ion_item, {
                                                            lines: "full",
                                                            class: "border-none",
                                                            style: {"--ion-item-border-color":"#ccc"}
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_component_ion_label, {
                                                                position: "floating",
                                                                class: "friColor1 fs-6"
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createTextVNode("Espesor del panel (mm) *")
                                                                ]),
                                                                _: 1
                                                              }),
                                                              _createVNode(_component_ion_input, {
                                                                modelValue: _ctx.layout.scene.specs.thickness,
                                                                "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.layout.scene.specs.thickness) = $event)),
                                                                type: "text",
                                                                autocomplete: "off"
                                                              }, null, 8, ["modelValue"])
                                                            ]),
                                                            _: 1
                                                          })
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 1
                                                  }))
                                                : _createCommentVNode("", true),
                                              (_ctx.layout.scene.specs.hasOwnProperty('compressor'))
                                                ? (_openBlock(), _createBlock(_component_ion_row, { key: 1 }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_ion_col, { class: "m-0 p-0" }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_ion_item, {
                                                            lines: "full",
                                                            class: "border-none",
                                                            style: {"--ion-item-border-color":"#ccc"}
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_component_ion_label, {
                                                                position: "floating",
                                                                class: "friColor1 fs-6"
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createTextVNode("Marca compressor *")
                                                                ]),
                                                                _: 1
                                                              }),
                                                              _createVNode(_component_ion_input, {
                                                                modelValue: _ctx.layout.scene.specs.compressor.brand,
                                                                "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.layout.scene.specs.compressor.brand) = $event)),
                                                                type: "text",
                                                                autocomplete: "off"
                                                              }, null, 8, ["modelValue"])
                                                            ]),
                                                            _: 1
                                                          })
                                                        ]),
                                                        _: 1
                                                      }),
                                                      _createVNode(_component_ion_col, { class: "m-0 p-0" }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_ion_item, {
                                                            lines: "full",
                                                            class: "border-none",
                                                            style: {"--ion-item-border-color":"#ccc"}
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_component_ion_label, {
                                                                position: "floating",
                                                                class: "friColor1 fs-6"
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createTextVNode("Modelo compressor *")
                                                                ]),
                                                                _: 1
                                                              }),
                                                              _createVNode(_component_ion_input, {
                                                                modelValue: _ctx.layout.scene.specs.compressor.model,
                                                                "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.layout.scene.specs.compressor.model) = $event)),
                                                                type: "text",
                                                                autocomplete: "off"
                                                              }, null, 8, ["modelValue"])
                                                            ]),
                                                            _: 1
                                                          })
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 1
                                                  }))
                                                : _createCommentVNode("", true),
                                              _createVNode(_component_ion_item, {
                                                lines: "full",
                                                class: "border-none",
                                                style: {"--ion-item-border-color":"#ccc"}
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_ion_label, {
                                                    position: "floating",
                                                    class: "friColor1 fs-6"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode("Tipo de Refrigerante *")
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _createVNode(_component_ion_input, {
                                                    modelValue: _ctx.layout.scene.specs.compressor.refrigerant,
                                                    "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.layout.scene.specs.compressor.refrigerant) = $event)),
                                                    type: "text",
                                                    autocomplete: "off"
                                                  }, null, 8, ["modelValue"])
                                                ]),
                                                _: 1
                                              })
                                            ], 64))
                                          : _createCommentVNode("", true),
                                        (_ctx.layout.app.devices.devices && Object.keys(_ctx.layout.app.devices.devices).length)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_110, [
                                              _hoisted_111,
                                              _createVNode(_component_ion_item, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_ion_select, {
                                                    placeholder: "Seleccione los dispositivos",
                                                    multiple: true,
                                                    modelValue: _ctx.layout.scene.devices,
                                                    "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.layout.scene.devices) = $event)),
                                                    class: "fs-6"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.layout.app.devices.devices, (device) => {
                                                        return (_openBlock(), _createBlock(_component_ion_select_option, {
                                                          key: device.deviceId,
                                                          value: device.deviceId
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(device.name), 1)
                                                          ]),
                                                          _: 2
                                                        }, 1032, ["value"]))
                                                      }), 128))
                                                    ]),
                                                    _: 1
                                                  }, 8, ["modelValue"])
                                                ]),
                                                _: 1
                                              })
                                            ]))
                                          : _createCommentVNode("", true),
                                        (_ctx.layout.app.users && _ctx.layout.app.users.users && Object.keys(_ctx.layout.app.users.users).length)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_112, [
                                              _hoisted_113,
                                              _createVNode(_component_ion_item, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_ion_select, {
                                                    placeholder: "Seleccione los usuarios",
                                                    multiple: true,
                                                    modelValue: _ctx.layout.scene.users,
                                                    "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.layout.scene.users) = $event)),
                                                    class: "fs-6"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.layout.app.users.users, (userScene) => {
                                                        return (_openBlock(), _createBlock(_component_ion_select_option, {
                                                          key: userScene.id,
                                                          value: userScene.id
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(userScene.first) + " " + _toDisplayString(userScene.last), 1)
                                                          ]),
                                                          _: 2
                                                        }, 1032, ["value"]))
                                                      }), 128))
                                                    ]),
                                                    _: 1
                                                  }, 8, ["modelValue"])
                                                ]),
                                                _: 1
                                              })
                                            ]))
                                          : _createCommentVNode("", true),
                                        _createVNode(_component_ion_item, {
                                          class: "mt-2 border-none",
                                          lines: "full",
                                          style: {"--ion-item-border-color":"#ccc"}
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ion_label, null, {
                                              default: _withCtx(() => [
                                                _createTextVNode("Activa")
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_ion_toggle, {
                                              "enable-on-off-labels": true,
                                              slot: "end",
                                              modelValue: _ctx.layout.scene.active,
                                              "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.layout.scene.active) = $event))
                                            }, null, 8, ["modelValue"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    (_ctx.layout.scene.createdAt)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_114, [
                                          (_ctx.layout.scene.createdAt)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_115, _toDisplayString(_ctx.layout.helper.getDateFormatFb(_ctx.layout.scene.createdAt)), 1))
                                            : _createCommentVNode("", true),
                                          _createTextVNode("| "),
                                          (_ctx.layout.scene.updatedAt)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_116, " Actualizada el " + _toDisplayString(_ctx.layout.helper.getDateFormatFb(_ctx.layout.scene.updatedAt)), 1))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("div", {
                                      style: _normalizeStyle(_ctx.isMobile ? 'margin-top: 30px; margin-bottom: 80px;' : 'margin: 30px 0;')
                                    }, [
                                      _createElementVNode("div", _hoisted_117, [
                                        _createElementVNode("div", {
                                          class: "fw-bold friColor3 text-end float-end cursor-pointer me-5",
                                          onClick: _cache[39] || (_cache[39] = ($event: any) => (_ctx.removeScene()))
                                        }, "ELIMINAR"),
                                        _createElementVNode("div", {
                                          class: "fw-bold friColor1 text-end float-end cursor-pointer",
                                          onClick: _cache[40] || (_cache[40] = ($event: any) => (_ctx.saveScene()))
                                        }, "GUARDAR")
                                      ])
                                    ], 4)
                                  ])
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  (_ctx.layout.app.scenes)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_118, [
                                        _createElementVNode("span", _hoisted_119, [
                                          _createTextVNode("Escenas "),
                                          (_ctx.layout.app.scenes.scenes)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_120, [
                                                _createTextVNode("(" + _toDisplayString(Object.keys(_ctx.layout.app.scenes.scenes).length) + "/", 1),
                                                _createElementVNode("span", null, _toDisplayString(_ctx.layout.app.limits.scenes), 1),
                                                _createTextVNode(")")
                                              ]))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_121, [
                                          (_ctx.layout.app.limits && _ctx.layout.app.scenes.scenes && _ctx.layout.app.limits.scenes > Object.keys(_ctx.layout.app.scenes.scenes).length)
                                            ? (_openBlock(), _createBlock(_component_ion_icon, {
                                                key: 0,
                                                icon: _ctx.refreshOutline,
                                                onClick: _cache[41] || (_cache[41] = ($event: any) => (_ctx.reLoad())),
                                                class: _normalizeClass(["font-bold align-middle cursor-pointer pe-2", _ctx.isMobile ? 'fs-2' : 'fs-3'])
                                              }, null, 8, ["icon", "class"]))
                                            : _createCommentVNode("", true),
                                          _createVNode(_component_ion_icon, {
                                            icon: _ctx.add,
                                            onClick: _cache[42] || (_cache[42] = ($event: any) => (_ctx.layout.newScene.addBox = true)),
                                            class: _normalizeClass(["p-0 m-0 font-bold align-middle cursor-pointer", _ctx.isMobile ? 'fs-1' : 'fs-2'])
                                          }, null, 8, ["icon", "class"])
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.layout.app.scenes && _ctx.layout.app.scenes.scenes && Object.keys(_ctx.layout.app.scenes.scenes).length)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_122, [
                                        (_ctx.layout.app && _ctx.layout.app.scenes && _ctx.layout.app.scenes.scenes && Object.keys(_ctx.layout.app.scenes.scenes).length)
                                          ? (_openBlock(), _createBlock(_component_ion_list, { key: 0 }, {
                                              default: _withCtx(() => [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.layout.app.scenes.scenes, (scene, sceneId) => {
                                                  return (_openBlock(), _createBlock(_component_ion_item, {
                                                    detail: "",
                                                    key: sceneId,
                                                    style: {"--ion-item-border-color":"#e4e3e3"},
                                                    class: "cursor-pointer mb-3",
                                                    onClick: ($event: any) => (_ctx.selScene(scene))
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_ion_avatar, {
                                                        slot: "start",
                                                        class: "mt-0",
                                                        style: {"width":"60px","height":"60px"}
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createElementVNode("i", {
                                                            class: _normalizeClass(["bi bi-record-circle ps-1 friOpacity3", scene.active ? 'friColor1' : 'friColor4']),
                                                            style: {"font-size":"50px","opacity":"0.5"}
                                                          }, null, 2)
                                                        ]),
                                                        _: 2
                                                      }, 1024),
                                                      _createVNode(_component_ion_label, null, {
                                                        default: _withCtx(() => [
                                                          _createElementVNode("h2", _hoisted_123, _toDisplayString(scene.name), 1),
                                                          (scene.typeName)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_124, _toDisplayString(scene.typeName), 1))
                                                            : _createCommentVNode("", true),
                                                          (!scene.active)
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_125, "Inactiva"))
                                                            : _createCommentVNode("", true),
                                                          (scene.devices && scene.devices.length)
                                                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(scene.devices, (device) => {
                                                                return (_openBlock(), _createElementBlock("div", {
                                                                  key: device,
                                                                  class: _normalizeClass(["text-xs ps-2", _ctx.layout.app.devices?.devices[device]?.status?.alarm?.status && _ctx.layout.app.devices?.devices[device]?.status?.alarm?.alarms ? 'friColor3 fw-bold' : ''])
                                                                }, " - " + _toDisplayString(_ctx.layout.app.devices.devices[device].name), 3))
                                                              }), 128))
                                                            : _createCommentVNode("", true)
                                                        ]),
                                                        _: 2
                                                      }, 1024)
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["onClick"]))
                                                }), 128))
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true),
                                        _hoisted_126,
                                        _createElementVNode("div", _hoisted_127, [
                                          _createVNode(_component_ion_row, { class: "fs-6" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_col, { class: "m-0 p-0" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_ion_item, {
                                                    lines: "full",
                                                    class: "border-none",
                                                    style: {"--ion-item-border-color":"#ccc"}
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_ion_select, {
                                                        interface: "popover",
                                                        modelValue: _ctx.layout.exportData.type,
                                                        "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.layout.exportData.type) = $event)),
                                                        class: "border-none"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.layout.searchTypes, (type, index) => {
                                                            return (_openBlock(), _createBlock(_component_ion_select_option, {
                                                              key: index,
                                                              value: type.value
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(type.label), 1)
                                                              ]),
                                                              _: 2
                                                            }, 1032, ["value"]))
                                                          }), 128))
                                                        ]),
                                                        _: 1
                                                      }, 8, ["modelValue"])
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              }),
                                              (_ctx.layout.app?.devices?.devices)
                                                ? (_openBlock(), _createBlock(_component_ion_col, {
                                                    key: 0,
                                                    class: "m-0 p-0"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_ion_item, {
                                                        lines: "full",
                                                        class: "border-none ms-3",
                                                        style: {"--ion-item-border-color":"#ccc"}
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_ion_select, {
                                                            interface: "popover",
                                                            modelValue: _ctx.layout.exportData.deviceId,
                                                            "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.layout.exportData.deviceId) = $event)),
                                                            class: "border-none"
                                                          }, {
                                                            default: _withCtx(() => [
                                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.layout.app.devices.devices, (device, index) => {
                                                                return (_openBlock(), _createBlock(_component_ion_select_option, {
                                                                  key: index,
                                                                  value: device.deviceId
                                                                }, {
                                                                  default: _withCtx(() => [
                                                                    _createTextVNode(_toDisplayString((device.name.length > 22) ? device.name.substring(0, 22) + '...' : device.name), 1)
                                                                  ]),
                                                                  _: 2
                                                                }, 1032, ["value"]))
                                                              }), 128))
                                                            ]),
                                                            _: 1
                                                          }, 8, ["modelValue"])
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 1
                                                  }))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_ion_row, { class: "fs-6" }, {
                                            default: _withCtx(() => [
                                              (_ctx.layout.exportData.deviceId)
                                                ? (_openBlock(), _createBlock(_component_ion_col, {
                                                    key: 0,
                                                    class: "m-0 p-0 mt-5"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      (!_ctx.layout.exportLoading)
                                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                            _createElementVNode("a", {
                                                              class: "friBack4 py-3 px-5 text-dark br-5 ms-2",
                                                              onClick: _cache[45] || (_cache[45] = ($event: any) => (_ctx.getLogs('log')))
                                                            }, "REGISTROS PDF"),
                                                            _createElementVNode("a", {
                                                              class: "friBack4 py-3 px-5 text-dark br-5 ms-2",
                                                              onClick: _cache[46] || (_cache[46] = ($event: any) => (_ctx.getLogs('log','csv')))
                                                            }, "REGISTROS CSV"),
                                                            _createElementVNode("a", {
                                                              class: "friBack4 py-3 px-5 text-dark br-5 ms-2",
                                                              onClick: _cache[47] || (_cache[47] = ($event: any) => (_ctx.getLogs('alarm')))
                                                            }, "ALARMAS PDF")
                                                          ], 64))
                                                        : (_openBlock(), _createElementBlock("div", _hoisted_128, [
                                                            _createVNode(_component_ion_spinner, {
                                                              name: "crescent",
                                                              color: "primary"
                                                            })
                                                          ]))
                                                    ]),
                                                    _: 1
                                                  }))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _: 1
                                          })
                                        ])
                                      ]))
                                    : (_openBlock(), _createElementBlock("div", {
                                        key: 2,
                                        style: _normalizeStyle(_ctx.isMobile ? 'padding-top: 80px;' : '')
                                      }, _hoisted_131, 4))
                                ], 64))
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.layout.app && _ctx.layout.section == 'settings')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_132, [
                            _createElementVNode("div", _hoisted_133, [
                              _hoisted_134,
                              _createElementVNode("div", _hoisted_135, [
                                _createVNode(_component_ion_icon, {
                                  icon: _ctx.refreshOutline,
                                  onClick: _cache[48] || (_cache[48] = ($event: any) => (_ctx.reLoad())),
                                  class: _normalizeClass(["font-bold align-middle cursor-pointer", _ctx.isMobile ? 'fs-2' : 'fs-3'])
                                }, null, 8, ["icon", "class"])
                              ])
                            ]),
                            (_ctx.layout.app)
                              ? (_openBlock(), _createBlock(_component_ion_list, { key: 0 }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_136, [
                                      (_ctx.layout.app.logo)
                                        ? (_openBlock(), _createElementBlock("img", {
                                            key: 0,
                                            src: _ctx.layout.app.logo,
                                            class: "mt-5",
                                            style: {"width":"150px"}
                                          }, null, 8, _hoisted_137))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("div", null, [
                                        _createVNode(_component_IonButton, {
                                          fill: "none",
                                          class: "mt-1 px-0 mx-0",
                                          style: {"border":"none !important"}
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("input", {
                                              id: "file",
                                              hidden: "",
                                              type: "file",
                                              accept: "image/*",
                                              onChange: _cache[49] || (_cache[49] = ($event: any) => (_ctx.previewLogo($event)))
                                            }, null, 32),
                                            _hoisted_138
                                          ]),
                                          _: 1
                                        })
                                      ])
                                    ]),
                                    _createVNode(_component_ion_item, {
                                      lines: "full",
                                      class: "border-none",
                                      style: {"--ion-item-border-color":"#ccc"}
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_label, {
                                          position: "floating",
                                          class: _normalizeClass(["friColor1", _ctx.isMobile ? 'fs-4' : ' fs-5'])
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Nombre *")
                                          ]),
                                          _: 1
                                        }, 8, ["class"]),
                                        _createVNode(_component_ion_input, {
                                          modelValue: _ctx.layout.app.name,
                                          "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.layout.app.name) = $event)),
                                          type: "text"
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_ion_item, {
                                      lines: "full",
                                      class: "border-none",
                                      style: {"--ion-item-border-color":"#ccc"}
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_label, {
                                          position: "floating",
                                          class: "friColor1 fs-6'"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Cliente *")
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_ion_select, {
                                          interface: "popover",
                                          modelValue: _ctx.layout.app.clientId,
                                          "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.layout.app.clientId) = $event)),
                                          class: "pfInputValue pt-2"
                                        }, {
                                          default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.layout.clients?.clients, (client, clientId) => {
                                              return (_openBlock(), _createBlock(_component_ion_select_option, {
                                                key: clientId,
                                                value: clientId
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(client.first) + " " + _toDisplayString(client.last), 1)
                                                ]),
                                                _: 2
                                              }, 1032, ["value"]))
                                            }), 128))
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    (_ctx.layout.agents)
                                      ? (_openBlock(), _createBlock(_component_ion_item, {
                                          key: 0,
                                          lines: "full",
                                          class: "border-none",
                                          style: {"--ion-item-border-color":"#ccc"}
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ion_label, {
                                              position: "floating",
                                              class: "friColor1 fs-6'"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode("Agente *")
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_ion_select, {
                                              interface: "popover",
                                              modelValue: _ctx.layout.app.agentId,
                                              "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.layout.app.agentId) = $event)),
                                              class: "pfInputValue pt-2"
                                            }, {
                                              default: _withCtx(() => [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.layout.agents.agents, (agent, agentId) => {
                                                  return (_openBlock(), _createBlock(_component_ion_select_option, {
                                                    key: agentId,
                                                    value: agentId
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(agent.first) + " " + _toDisplayString(agent.last), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["value"]))
                                                }), 128))
                                              ]),
                                              _: 1
                                            }, 8, ["modelValue"])
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true),
                                    (_ctx.layout.app.hasOwnProperty('location'))
                                      ? (_openBlock(), _createBlock(_component_ion_item, {
                                          key: 1,
                                          lines: "full",
                                          class: "border-none",
                                          style: {"--ion-item-border-color":"#ccc"}
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ion_label, {
                                              position: "floating",
                                              class: "friColor1 fs-6"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode("Localización *")
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_ion_select, {
                                              interface: "popover",
                                              modelValue: _ctx.layout.app.location.cityId,
                                              "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.layout.app.location.cityId) = $event)),
                                              class: "pfInputValue pt-2"
                                            }, {
                                              default: _withCtx(() => [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.layout.weatherCities, (city) => {
                                                  return (_openBlock(), _createBlock(_component_ion_select_option, {
                                                    key: city.id,
                                                    value: city.id.toString()
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(city.name), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["value"]))
                                                }), 128))
                                              ]),
                                              _: 1
                                            }, 8, ["modelValue"])
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true),
                                    _createVNode(_component_ion_item, {
                                      class: "mt-2 border-none",
                                      lines: "full",
                                      style: {"--ion-item-border-color":"#ccc"}
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_label, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Activo")
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_ion_toggle, {
                                          "enable-on-off-labels": true,
                                          slot: "end",
                                          modelValue: _ctx.layout.app.active,
                                          "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.layout.app.active) = $event))
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    (!_ctx.layout.app.active)
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_139, "El cliente y sus usuarios no pueden acceder a los datos de sus dispositivos, ni recibir notificaciones."))
                                      : _createCommentVNode("", true),
                                    (_ctx.layout.app.hasOwnProperty('limits'))
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                          _hoisted_140,
                                          _hoisted_141,
                                          _createVNode(_component_ion_row, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_col, { class: "m-0 p-0" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_ion_item, {
                                                    lines: "full",
                                                    class: "border-none",
                                                    style: {"--ion-item-border-color":"#ccc"}
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_ion_label, {
                                                        position: "floating",
                                                        class: "friColor1 fs-6"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode("Dispositivos")
                                                        ]),
                                                        _: 1
                                                      }),
                                                      _createVNode(_component_ion_input, {
                                                        modelValue: _ctx.layout.app.limits.devices,
                                                        "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.layout.app.limits.devices) = $event)),
                                                        type: "text"
                                                      }, null, 8, ["modelValue"])
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_component_ion_col, { class: "m-0 p-0" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_ion_item, {
                                                    lines: "full",
                                                    class: "border-none",
                                                    style: {"--ion-item-border-color":"#ccc"}
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_ion_label, {
                                                        position: "floating",
                                                        class: "friColor1 fs-6"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode("Usuarios")
                                                        ]),
                                                        _: 1
                                                      }),
                                                      _createVNode(_component_ion_input, {
                                                        modelValue: _ctx.layout.app.limits.users,
                                                        "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.layout.app.limits.users) = $event)),
                                                        type: "text"
                                                      }, null, 8, ["modelValue"])
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_component_ion_col, { class: "m-0 p-0" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_ion_item, {
                                                    lines: "full",
                                                    class: "border-none",
                                                    style: {"--ion-item-border-color":"#ccc"}
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_ion_label, {
                                                        position: "floating",
                                                        class: "friColor1 fs-6"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode("Escenas")
                                                        ]),
                                                        _: 1
                                                      }),
                                                      _createVNode(_component_ion_input, {
                                                        modelValue: _ctx.layout.app.limits.scenes,
                                                        "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((_ctx.layout.app.limits.scenes) = $event)),
                                                        type: "text"
                                                      }, null, 8, ["modelValue"])
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_ion_item, {
                                            class: "mt-2 border-none",
                                            lines: "full",
                                            style: {"--ion-item-border-color":"#ccc"}
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_label, null, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("Historial")
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_component_ion_toggle, {
                                                "enable-on-off-labels": true,
                                                slot: "end",
                                                modelValue: _ctx.layout.app.limits.reports.log,
                                                "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((_ctx.layout.app.limits.reports.log) = $event))
                                              }, null, 8, ["modelValue"])
                                            ]),
                                            _: 1
                                          }),
                                          (_ctx.layout.app.limits.reports.log)
                                            ? (_openBlock(), _createBlock(_component_ion_item, {
                                                key: 0,
                                                class: "mt-2 border-none",
                                                lines: "full",
                                                style: {"--ion-item-border-color":"#ccc"}
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_ion_label, null, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode("Exportación")
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _createVNode(_component_ion_toggle, {
                                                    "enable-on-off-labels": true,
                                                    slot: "end",
                                                    modelValue: _ctx.layout.app.limits.reports.share,
                                                    "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => ((_ctx.layout.app.limits.reports.share) = $event))
                                                  }, null, 8, ["modelValue"])
                                                ]),
                                                _: 1
                                              }))
                                            : _createCommentVNode("", true),
                                          (_ctx.layout.app.limits.notify)
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                _hoisted_142,
                                                _createVNode(_component_ion_item, {
                                                  class: "mt-2 border-none",
                                                  lines: "full",
                                                  style: {"--ion-item-border-color":"#ccc"}
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_ion_label, null, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode("Historial")
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_ion_toggle, {
                                                      "enable-on-off-labels": true,
                                                      slot: "end",
                                                      modelValue: _ctx.layout.app.limits.alarms.log,
                                                      "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => ((_ctx.layout.app.limits.alarms.log) = $event))
                                                    }, null, 8, ["modelValue"])
                                                  ]),
                                                  _: 1
                                                }),
                                                (_ctx.layout.app.limits.alarms.log)
                                                  ? (_openBlock(), _createBlock(_component_ion_item, {
                                                      key: 0,
                                                      class: "mt-2 border-none",
                                                      lines: "full",
                                                      style: {"--ion-item-border-color":"#ccc"}
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_ion_label, null, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode("Exportación")
                                                          ]),
                                                          _: 1
                                                        }),
                                                        _createVNode(_component_ion_toggle, {
                                                          "enable-on-off-labels": true,
                                                          slot: "end",
                                                          modelValue: _ctx.layout.app.limits.alarms.share,
                                                          "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => ((_ctx.layout.app.limits.alarms.share) = $event))
                                                        }, null, 8, ["modelValue"])
                                                      ]),
                                                      _: 1
                                                    }))
                                                  : _createCommentVNode("", true),
                                                _createVNode(_component_ion_item, {
                                                  class: "border-none",
                                                  lines: "full",
                                                  style: {"--ion-item-border-color":"#ccc"}
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_ion_label, null, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode("Email")
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_ion_toggle, {
                                                      "enable-on-off-labels": true,
                                                      slot: "end",
                                                      modelValue: _ctx.layout.app.limits.notify.email,
                                                      "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => ((_ctx.layout.app.limits.notify.email) = $event))
                                                    }, null, 8, ["modelValue"])
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_ion_item, {
                                                  class: "mt-2 border-none",
                                                  lines: "full",
                                                  style: {"--ion-item-border-color":"#ccc"}
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_ion_label, null, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode("Whatsapp")
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_ion_toggle, {
                                                      "enable-on-off-labels": true,
                                                      slot: "end",
                                                      modelValue: _ctx.layout.app.limits.notify.whatsapp,
                                                      "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => ((_ctx.layout.app.limits.notify.whatsapp) = $event))
                                                    }, null, 8, ["modelValue"])
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_ion_item, {
                                                  class: "mt-2 border-none",
                                                  lines: "full",
                                                  style: {"--ion-item-border-color":"#ccc"}
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_ion_label, null, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode("SMS")
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_ion_toggle, {
                                                      "enable-on-off-labels": true,
                                                      slot: "end",
                                                      modelValue: _ctx.layout.app.limits.notify.sms,
                                                      "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event: any) => ((_ctx.layout.app.limits.notify.sms) = $event))
                                                    }, null, 8, ["modelValue"])
                                                  ]),
                                                  _: 1
                                                }),
                                                (_ctx.layout.app.limits.notify.sms)
                                                  ? (_openBlock(), _createBlock(_component_ion_item, {
                                                      key: 1,
                                                      lines: "full",
                                                      class: "border-none",
                                                      style: {"--ion-item-border-color":"#ccc"}
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_ion_label, {
                                                          position: "floating",
                                                          class: "friColor1 fs-6"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode("Límite SMS")
                                                          ]),
                                                          _: 1
                                                        }),
                                                        _createVNode(_component_ion_input, {
                                                          modelValue: _ctx.layout.app.limits.notify.maxsms,
                                                          "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => ((_ctx.layout.app.limits.notify.maxsms) = $event)),
                                                          type: "text"
                                                        }, null, 8, ["modelValue"])
                                                      ]),
                                                      _: 1
                                                    }))
                                                  : _createCommentVNode("", true)
                                              ], 64))
                                            : _createCommentVNode("", true)
                                        ], 64))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", {
                              style: _normalizeStyle(_ctx.isMobile ? 'margin-top: 30px; margin-bottom: 80px;' : 'margin: 30px 0;')
                            }, [
                              _createElementVNode("div", _hoisted_143, [
                                ((!_ctx.layout.app.devices || !_ctx.layout.app.devices.devices && !_ctx.layout.app.gateways || !_ctx.layout.app.gateways.gateways))
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 0,
                                      class: "pe-4 fw-bold text-danger friOpacity8 cursor-pointer pe-4",
                                      onClick: _cache[66] || (_cache[66] = ($event: any) => (_ctx.removeApp()))
                                    }, "ELIMINAR"))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", {
                                  class: "fw-bold friColor1 text-end float-end cursor-pointer",
                                  onClick: _cache[67] || (_cache[67] = ($event: any) => (_ctx.saveApp()))
                                }, "GUARDAR")
                              ])
                            ], 4)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.layout.app && _ctx.layout.section == 'users')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_144, [
                            _createElementVNode("div", _hoisted_145, [
                              _createElementVNode("span", _hoisted_146, [
                                _createTextVNode("Usuarios "),
                                (_ctx.layout.appId && _ctx.layout.app.users && _ctx.layout.app.users.users && Object.keys(_ctx.layout.app.users.users).length)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_147, "(" + _toDisplayString(Object.keys(_ctx.layout.app.users.users).length) + ")", 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", {
                                fill: "clear",
                                class: "float-end me-3 cursor-pointer fs-6 pt-1",
                                onClick: _cache[68] || (_cache[68] = ($event: any) => (_ctx.$router.push({ path: '/app/'+ _ctx.layout.app.id, query: { section:  'settings' } })))
                              }, "Límite " + _toDisplayString(_ctx.layout.app.limits.users), 1)
                            ]),
                            (_ctx.layout.appId && _ctx.layout.app.users && _ctx.layout.app.users.users && Object.keys(_ctx.layout.app.users.users).length)
                              ? (_openBlock(), _createBlock(_component_ion_list, {
                                  key: 0,
                                  style: {"background-color":"#fff !important"}
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.layout.app.users.users, (user, userId) => {
                                      return (_openBlock(), _createBlock(_component_ion_item, {
                                        key: userId,
                                        style: {"--ion-item-border-color":"#e4e3e3"}
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_avatar, {
                                            slot: "start",
                                            style: {"width":"55px","height":"50px"},
                                            class: "text-center"
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("div", _hoisted_148, _toDisplayString(user.first[0]) + _toDisplayString(user.last[0]), 1)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_ion_label, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_row, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_ion_col, null, {
                                                    default: _withCtx(() => [
                                                      _createElementVNode("h2", _hoisted_149, _toDisplayString(user.first) + " " + _toDisplayString(user.last), 1),
                                                      (user.email)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_150, _toDisplayString(user.email), 1))
                                                        : _createCommentVNode("", true),
                                                      (user.createdAt)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_151, "Creado el: " + _toDisplayString(_ctx.layout.helper.getDateFormatFb(user.createdAt)), 1))
                                                        : _createCommentVNode("", true),
                                                      (user.updatedAt)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_152, "Actualizado el: " + _toDisplayString(_ctx.layout.helper.getDateFormatFb(user.updatedAt)), 1))
                                                        : _createCommentVNode("", true),
                                                      (user.lastLogin)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_153, "Último inicio de sesión: " + _toDisplayString(_ctx.layout.helper.getDateFormatFb(user.lastLogin)), 1))
                                                        : _createCommentVNode("", true)
                                                    ]),
                                                    _: 2
                                                  }, 1024),
                                                  _createVNode(_component_ion_col, { class: "mt-1" }, {
                                                    default: _withCtx(() => [
                                                      _hoisted_154,
                                                      (user.notify && user.notify.email)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_155, "- Email"))
                                                        : _createCommentVNode("", true),
                                                      (user.notify && user.notify.whatsapp)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_156, "- Whatsapp"))
                                                        : _createCommentVNode("", true),
                                                      (user.notify && user.notify.sms)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_157, "- SMS"))
                                                        : _createCommentVNode("", true),
                                                      (!user.active)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_158, _hoisted_160))
                                                        : _createCommentVNode("", true)
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1024))
                                    }), 128))
                                  ]),
                                  _: 1
                                }))
                              : (_openBlock(), _createElementBlock("div", _hoisted_161, _hoisted_163))
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_ion_modal, {
                        "is-open": _ctx.layout.addGateway,
                        "backdrop-dismiss": false
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_header, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_buttons, { slot: "end" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_button, {
                                    onClick: _cache[69] || (_cache[69] = ($event: any) => (_ctx.$router.push('/app/' + _ctx.layout.appId))),
                                    class: "border-none"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Cerrar")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_content, null, {
                            default: _withCtx(() => [
                              (!_ctx.layout.modalLoading)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    (!_ctx.isMobile)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_164, [
                                          _hoisted_165,
                                          _createElementVNode("span", _hoisted_166, [
                                            _createElementVNode("span", _hoisted_167, _toDisplayString(_ctx.layout.newGateway.gatewayId), 1)
                                          ])
                                        ]))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_168, [
                                          _hoisted_169,
                                          _hoisted_170,
                                          _createElementVNode("span", _hoisted_171, _toDisplayString(_ctx.layout.newGateway.gatewayId), 1)
                                        ])),
                                    _createElementVNode("div", _hoisted_172, [
                                      _createVNode(_component_ion_list, { class: "m-0 p-0" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_item, {
                                            lines: "full",
                                            class: "border-none",
                                            style: {"--ion-item-border-color":"#ccc"}
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_label, {
                                                position: "floating",
                                                class: _normalizeClass(["friColor1", _ctx.isMobile ? 'fs-4' : ' fs-5'])
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("Nombre *")
                                                ]),
                                                _: 1
                                              }, 8, ["class"]),
                                              _createVNode(_component_ion_input, {
                                                modelValue: _ctx.layout.newGateway.name,
                                                "onUpdate:modelValue": _cache[70] || (_cache[70] = ($event: any) => ((_ctx.layout.newGateway.name) = $event)),
                                                type: "text",
                                                autocomplete: "off"
                                              }, null, 8, ["modelValue"])
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_ion_item, {
                                            lines: "full",
                                            class: "border-none",
                                            style: {"--ion-item-border-color":"#ccc"}
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_label, {
                                                position: "floating",
                                                class: _normalizeClass(["friColor1", _ctx.isMobile ? 'fs-4' : ' fs-5'])
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("EUI *")
                                                ]),
                                                _: 1
                                              }, 8, ["class"]),
                                              _createVNode(_component_ion_input, {
                                                modelValue: _ctx.layout.newGateway.eui,
                                                "onUpdate:modelValue": _cache[71] || (_cache[71] = ($event: any) => ((_ctx.layout.newGateway.eui) = $event)),
                                                type: "text",
                                                autocomplete: "off"
                                              }, null, 8, ["modelValue"])
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_ion_item, {
                                            lines: "full",
                                            class: "border-none",
                                            style: {"--ion-item-border-color":"#ccc"}
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_label, {
                                                position: "floating",
                                                class: _normalizeClass(["friColor1", _ctx.isMobile ? 'fs-4' : ' fs-5'])
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("Servidor *")
                                                ]),
                                                _: 1
                                              }, 8, ["class"]),
                                              _createVNode(_component_ion_input, {
                                                modelValue: _ctx.layout.newGateway.serverAdress,
                                                "onUpdate:modelValue": _cache[72] || (_cache[72] = ($event: any) => ((_ctx.layout.newGateway.serverAdress) = $event)),
                                                type: "text",
                                                autocomplete: "off"
                                              }, null, 8, ["modelValue"])
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_ion_item, {
                                            lines: "full",
                                            class: "border-none",
                                            style: {"--ion-item-border-color":"#ccc"}
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_label, {
                                                position: "floating",
                                                class: _normalizeClass(["friColor1", _ctx.isMobile ? 'fs-4' : ' fs-5'])
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("Frecuencia *")
                                                ]),
                                                _: 1
                                              }, 8, ["class"]),
                                              _createVNode(_component_ion_select, {
                                                interface: "popover",
                                                modelValue: _ctx.layout.newGateway.frequencyPlanId,
                                                "onUpdate:modelValue": _cache[73] || (_cache[73] = ($event: any) => ((_ctx.layout.newGateway.frequencyPlanId) = $event)),
                                                class: "pfInputValue"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_ion_select_option, { value: "EU_863_870_TTN" }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode("EU_863_870_TTN")
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              }, 8, ["modelValue"])
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_ion_item, {
                                            lines: "full",
                                            class: "border-none",
                                            style: {"--ion-item-border-color":"#ccc"}
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_label, {
                                                position: "floating",
                                                class: _normalizeClass(["friColor1", _ctx.isMobile ? 'fs-4' : ' fs-5'])
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("Marca")
                                                ]),
                                                _: 1
                                              }, 8, ["class"]),
                                              _createVNode(_component_ion_input, {
                                                modelValue: _ctx.layout.newGateway.device.brand,
                                                "onUpdate:modelValue": _cache[74] || (_cache[74] = ($event: any) => ((_ctx.layout.newGateway.device.brand) = $event)),
                                                type: "text",
                                                autocomplete: "off"
                                              }, null, 8, ["modelValue"])
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_ion_item, {
                                            lines: "full",
                                            class: "border-none",
                                            style: {"--ion-item-border-color":"#ccc"}
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_label, {
                                                position: "floating",
                                                class: _normalizeClass(["friColor1", _ctx.isMobile ? 'fs-4' : ' fs-5'])
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("Modelo")
                                                ]),
                                                _: 1
                                              }, 8, ["class"]),
                                              _createVNode(_component_ion_input, {
                                                modelValue: _ctx.layout.newGateway.device.model,
                                                "onUpdate:modelValue": _cache[75] || (_cache[75] = ($event: any) => ((_ctx.layout.newGateway.device.model) = $event)),
                                                type: "text",
                                                autocomplete: "off"
                                              }, null, 8, ["modelValue"])
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_ion_item, {
                                            lines: "full",
                                            class: "border-none",
                                            style: {"--ion-item-border-color":"#ccc"}
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_label, {
                                                position: "floating",
                                                class: _normalizeClass(["friColor1", _ctx.isMobile ? 'fs-4' : ' fs-5'])
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("Serial")
                                                ]),
                                                _: 1
                                              }, 8, ["class"]),
                                              _createVNode(_component_ion_input, {
                                                modelValue: _ctx.layout.newGateway.device.serial,
                                                "onUpdate:modelValue": _cache[76] || (_cache[76] = ($event: any) => ((_ctx.layout.newGateway.device.serial) = $event)),
                                                type: "text",
                                                autocomplete: "off"
                                              }, null, 8, ["modelValue"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _createElementVNode("div", _hoisted_173, [
                                      _createElementVNode("div", _hoisted_174, [
                                        _createElementVNode("button", {
                                          class: "button px-5 py-1 m-0 mt-0 bg-light",
                                          onClick: _cache[77] || (_cache[77] = ($event: any) => (_ctx.layout.addGateway = false))
                                        }, "Cancelar"),
                                        _createElementVNode("button", {
                                          class: "button px-5 py-1 ms-3 fw-bold friBack1 text-white",
                                          onClick: _cache[78] || (_cache[78] = ($event: any) => (_ctx.addGateway()))
                                        }, "Crear")
                                      ])
                                    ])
                                  ], 64))
                                : (_openBlock(), _createElementBlock("div", _hoisted_175, [
                                    _hoisted_176,
                                    _createElementVNode("div", _hoisted_177, _toDisplayString(_ctx.layout.newGateway.name), 1),
                                    _hoisted_178,
                                    _hoisted_179
                                  ]))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["is-open"]),
                      _createVNode(_component_ion_modal, {
                        "is-open": _ctx.layout.newDevice && _ctx.layout.newDevice.addBox,
                        "backdrop-dismiss": false
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_header, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_buttons, { slot: "end" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_button, {
                                    onClick: _cache[79] || (_cache[79] = ($event: any) => (_ctx.$router.push('/app/' + _ctx.layout.appId))),
                                    class: "border-none"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Cerrar")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_content, null, {
                            default: _withCtx(() => [
                              (!_ctx.layout.newDevice.loading)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    (!_ctx.isMobile)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_180, [
                                          _hoisted_181,
                                          _createElementVNode("span", _hoisted_182, [
                                            _createElementVNode("span", _hoisted_183, _toDisplayString(_ctx.layout.newDevice.deviceId), 1)
                                          ])
                                        ]))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_184, [
                                          _hoisted_185,
                                          _hoisted_186,
                                          _createElementVNode("span", _hoisted_187, _toDisplayString(_ctx.layout.newDevice.deviceId), 1)
                                        ])),
                                    _createElementVNode("div", _hoisted_188, [
                                      _createVNode(_component_ion_list, { class: "m-0 p-0" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_item, {
                                            lines: "full",
                                            class: "border-none",
                                            style: {"--ion-item-border-color":"#ccc"}
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_label, {
                                                position: "floating",
                                                class: _normalizeClass(["friColor1", _ctx.isMobile ? 'fs-4' : ' fs-5'])
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("Dispositivo *")
                                                ]),
                                                _: 1
                                              }, 8, ["class"]),
                                              _createVNode(_component_ion_select, {
                                                interface: "popover",
                                                modelValue: _ctx.layout.newDevice.type,
                                                "onUpdate:modelValue": _cache[80] || (_cache[80] = ($event: any) => ((_ctx.layout.newDevice.type) = $event)),
                                                class: "pfInputValue"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_ion_select_option, { value: "dht" }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode("Sensor de humedad y temperatura (LHT65N)")
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _createVNode(_component_ion_select_option, { value: "dht52" }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode("Sensor de humedad y temperatura (LHT52)")
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _createVNode(_component_ion_select_option, { value: "lds02" }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode("Contacto magnético para puerta (LDS02)")
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _createVNode(_component_ion_select_option, { value: "aqs01l" }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode("Sensor CO2 (AQS01-L)")
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _createVNode(_component_ion_select_option, { value: "xw265k" }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode("C15-XW265K")
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _createVNode(_component_ion_select_option, { value: "ct101" }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode("CT101")
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              }, 8, ["modelValue"])
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_ion_item, {
                                            lines: "full",
                                            class: "border-none",
                                            style: {"--ion-item-border-color":"#ccc"}
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_label, {
                                                position: "floating",
                                                class: _normalizeClass(["friColor1", _ctx.isMobile ? 'fs-4' : ' fs-5'])
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("Nombre *")
                                                ]),
                                                _: 1
                                              }, 8, ["class"]),
                                              _createVNode(_component_ion_input, {
                                                modelValue: _ctx.layout.newDevice.name,
                                                "onUpdate:modelValue": _cache[81] || (_cache[81] = ($event: any) => ((_ctx.layout.newDevice.name) = $event)),
                                                type: "text",
                                                autocomplete: "off"
                                              }, null, 8, ["modelValue"])
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_ion_item, {
                                            lines: "full",
                                            class: "border-none",
                                            style: {"--ion-item-border-color":"#ccc"}
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_label, {
                                                position: "floating",
                                                class: _normalizeClass(["friColor1", _ctx.isMobile ? 'fs-4' : ' fs-5'])
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("AppEUI *")
                                                ]),
                                                _: 1
                                              }, 8, ["class"]),
                                              _createVNode(_component_ion_input, {
                                                modelValue: _ctx.layout.newDevice.eui,
                                                "onUpdate:modelValue": _cache[82] || (_cache[82] = ($event: any) => ((_ctx.layout.newDevice.eui) = $event)),
                                                type: "text",
                                                autocomplete: "off"
                                              }, null, 8, ["modelValue"])
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_ion_item, {
                                            lines: "full",
                                            class: "border-none",
                                            style: {"--ion-item-border-color":"#ccc"}
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_label, {
                                                position: "floating",
                                                class: _normalizeClass(["friColor1", _ctx.isMobile ? 'fs-4' : ' fs-5'])
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("AppKey *")
                                                ]),
                                                _: 1
                                              }, 8, ["class"]),
                                              _createVNode(_component_ion_input, {
                                                modelValue: _ctx.layout.newDevice.key,
                                                "onUpdate:modelValue": _cache[83] || (_cache[83] = ($event: any) => ((_ctx.layout.newDevice.key) = $event)),
                                                type: "text",
                                                autocomplete: "off"
                                              }, null, 8, ["modelValue"])
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_ion_item, {
                                            lines: "full",
                                            class: "border-none",
                                            style: {"--ion-item-border-color":"#ccc"}
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_label, {
                                                position: "floating",
                                                class: _normalizeClass(["friColor1", _ctx.isMobile ? 'fs-4' : ' fs-5'])
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("DevEUI *")
                                                ]),
                                                _: 1
                                              }, 8, ["class"]),
                                              _createVNode(_component_ion_input, {
                                                modelValue: _ctx.layout.newDevice.deveui,
                                                "onUpdate:modelValue": _cache[84] || (_cache[84] = ($event: any) => ((_ctx.layout.newDevice.deveui) = $event)),
                                                type: "text",
                                                autocomplete: "off"
                                              }, null, 8, ["modelValue"])
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_ion_item, {
                                            lines: "full",
                                            class: "border-none",
                                            style: {"--ion-item-border-color":"#ccc"}
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_label, {
                                                position: "floating",
                                                class: _normalizeClass(["friColor1", _ctx.isMobile ? 'fs-4' : ' fs-5'])
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("Network Server address *")
                                                ]),
                                                _: 1
                                              }, 8, ["class"]),
                                              _createVNode(_component_ion_input, {
                                                modelValue: _ctx.layout.newDevice.networkServerAddress,
                                                "onUpdate:modelValue": _cache[85] || (_cache[85] = ($event: any) => ((_ctx.layout.newDevice.networkServerAddress) = $event)),
                                                type: "text",
                                                autocomplete: "off"
                                              }, null, 8, ["modelValue"])
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_ion_item, {
                                            lines: "full",
                                            class: "border-none",
                                            style: {"--ion-item-border-color":"#ccc"}
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_label, {
                                                position: "floating",
                                                class: _normalizeClass(["friColor1", _ctx.isMobile ? 'fs-4' : ' fs-5'])
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("Application Server address *")
                                                ]),
                                                _: 1
                                              }, 8, ["class"]),
                                              _createVNode(_component_ion_input, {
                                                modelValue: _ctx.layout.newDevice.joinServerAddress,
                                                "onUpdate:modelValue": _cache[86] || (_cache[86] = ($event: any) => ((_ctx.layout.newDevice.joinServerAddress) = $event)),
                                                type: "text",
                                                autocomplete: "off"
                                              }, null, 8, ["modelValue"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _createElementVNode("div", _hoisted_189, [
                                      _createElementVNode("div", _hoisted_190, [
                                        _createElementVNode("button", {
                                          class: "button px-5 py-1 m-0 mt-0 bg-light",
                                          onClick: _cache[87] || (_cache[87] = ($event: any) => (_ctx.layout.newDevice.addBox = false))
                                        }, "Cancelar"),
                                        _createElementVNode("button", {
                                          class: "button px-5 py-1 ms-3 fw-bold friBack1 text-white",
                                          onClick: _cache[88] || (_cache[88] = ($event: any) => (_ctx.addDevice()))
                                        }, "Crear")
                                      ])
                                    ])
                                  ], 64))
                                : (_openBlock(), _createElementBlock("div", _hoisted_191, [
                                    _hoisted_192,
                                    _createElementVNode("div", _hoisted_193, _toDisplayString(_ctx.layout.newDevice.name), 1),
                                    _hoisted_194,
                                    _hoisted_195
                                  ]))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["is-open"]),
                      _createVNode(_component_ion_modal, {
                        "is-open": _ctx.layout.newScene && _ctx.layout.newScene.addBox,
                        "backdrop-dismiss": false
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_header, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_buttons, { slot: "end" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_button, {
                                    onClick: _cache[89] || (_cache[89] = ($event: any) => (_ctx.$router.push('/app/' + _ctx.layout.appId))),
                                    class: "border-none"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Cerrar")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_content, null, {
                            default: _withCtx(() => [
                              (!_ctx.layout.newScene.loading)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    (!_ctx.isMobile)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_196, _hoisted_198))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_199, [
                                          _hoisted_200,
                                          _hoisted_201,
                                          _createElementVNode("div", _hoisted_202, _toDisplayString(_ctx.layout.app.name), 1)
                                        ])),
                                    _createElementVNode("div", {
                                      class: _normalizeClass(["mx-5 pt-3 mb-3", _ctx.isMobile ? 'text-center' : 'text-left mb-3'])
                                    }, " Las escenas son espacios virtuales que representan un área de trabajo o un lugar físico que le permiten agrupar dispositivos para su control y seguimiento. ", 2),
                                    _createElementVNode("div", _hoisted_203, [
                                      _createVNode(_component_ion_list, { class: "m-0 p-0" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_item, {
                                            lines: "full",
                                            class: "border-none",
                                            style: {"--ion-item-border-color":"#ccc"}
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_label, {
                                                position: "floating",
                                                class: _normalizeClass(["friColor1", _ctx.isMobile ? 'fs-4' : ' fs-5'])
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("Tipo *")
                                                ]),
                                                _: 1
                                              }, 8, ["class"]),
                                              _createVNode(_component_ion_select, {
                                                interface: "popover",
                                                modelValue: _ctx.layout.newScene.type,
                                                "onUpdate:modelValue": _cache[90] || (_cache[90] = ($event: any) => ((_ctx.layout.newScene.type) = $event)),
                                                class: "pfInputValue"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_ion_select_option, { value: "coldroom" }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode("Cámara frigorífica")
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _createVNode(_component_ion_select_option, { value: "handlingroom" }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode("Sala de manipulación")
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              }, 8, ["modelValue"])
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_ion_item, {
                                            lines: "full",
                                            class: "border-none",
                                            style: {"--ion-item-border-color":"#ccc"}
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_label, {
                                                position: "floating",
                                                class: _normalizeClass(["friColor1", _ctx.isMobile ? 'fs-4' : ' fs-5'])
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("Nombre *")
                                                ]),
                                                _: 1
                                              }, 8, ["class"]),
                                              _createVNode(_component_ion_input, {
                                                modelValue: _ctx.layout.newScene.name,
                                                "onUpdate:modelValue": _cache[91] || (_cache[91] = ($event: any) => ((_ctx.layout.newScene.name) = $event)),
                                                type: "text",
                                                autocomplete: "off"
                                              }, null, 8, ["modelValue"])
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_ion_item, {
                                            lines: "full",
                                            class: "border-none",
                                            style: {"--ion-item-border-color":"#ccc"}
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_label, {
                                                position: "floating",
                                                class: "friColor1 fs-6"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("Tipología del producto *")
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_component_ion_input, {
                                                modelValue: _ctx.layout.newScene.specs.product.type,
                                                "onUpdate:modelValue": _cache[92] || (_cache[92] = ($event: any) => ((_ctx.layout.newScene.specs.product.type) = $event)),
                                                type: "text",
                                                autocomplete: "off"
                                              }, null, 8, ["modelValue"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _createElementVNode("div", _hoisted_204, [
                                      _createElementVNode("div", _hoisted_205, [
                                        _createElementVNode("button", {
                                          class: "button px-5 py-1 m-0 mt-0 bg-light",
                                          onClick: _cache[93] || (_cache[93] = ($event: any) => (_ctx.layout.newScene.addBox = false))
                                        }, "Cancelar"),
                                        _createElementVNode("button", {
                                          class: "button px-5 py-1 ms-3 fw-bold friBack1 text-white",
                                          onClick: _cache[94] || (_cache[94] = ($event: any) => (_ctx.addScene()))
                                        }, "Crear")
                                      ])
                                    ])
                                  ], 64))
                                : (_openBlock(), _createElementBlock("div", _hoisted_206, [
                                    _hoisted_207,
                                    _createElementVNode("div", _hoisted_208, _toDisplayString(_ctx.layout.newDevice.name), 1),
                                    _hoisted_209,
                                    _hoisted_210
                                  ]))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["is-open"])
                    ], 64))
                  : (_openBlock(), _createElementBlock("div", _hoisted_211, _hoisted_215))
              ], 2)
            ], 4))
          : (_openBlock(), _createElementBlock("div", _hoisted_216, _hoisted_220))
      ], 6)
    ])
  ], 2))
}